/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(20), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, editHoldingsHelper, inputDatapointMapping) {
    'use strict';

    var transformHelper = {
        generateIWTPostData: generateIWTPostData,
        generateIWTFeesPostData: generateIWTFeesPostData,
        generatePAAPIPortfolios: generatePAAPIPortfolios,
        generateEditHoldings: generateEditHoldings,
        generateBaseUrl: generateBaseUrl,
        handleIWTReturnData: handleIWTReturnData,
        generatePAAPIUrlParameters: generatePAAPIUrlParameters,
        getAssetClassGroupId: getAssetClassGroupId,
        getBenchmarkId: getBenchmarkId,
        addAsOfDate: addAsOfDate,
        benchmarkHandlerOfUS: benchmarkHandlerOfUS
    };

    angular.module('ecPortfolioData').factory('portfolioDataTransformHelperService', function () {
        return transformHelper;
    });

    return transformHelper;

    function generateIWTPostData(context, parameters, type) {
        var portfolio = null;
        if (type) {
            portfolio = parameters.portfolio[type];
        } else {
            portfolio = parameters.portfolio;
        }

        return {
            parameters: formatIWTAPIParameters(context, portfolio),
            requestData: formatIWTAPIRequestData(context, portfolio)
        };
    }

    function generateIWTFeesPostData(context, parameters, type) {
        var portfolio = null;
        if (type) {
            portfolio = parameters.portfolio[type];
        } else {
            portfolio = parameters.portfolio;
        }

        var portfoliofeesSettings = parameters.feesSettings,
            holdings = portfolio.holdings || [],
            holdingType = editHoldingsHelper.generateHoldingType(holdings),
            totalAmount = editHoldingsHelper.calculateTotalAmount(holdings),
            newPortfolio = {
            id: type || 'default',
            amount: 10000,
            holdings: []
        };
        portfoliofeesSettings.portfolios = [];
        if (holdingType === 'amount') {
            _.each(holdings, function (holding) {
                holding.weight = holding.amount / totalAmount * 100.0;
            });
        }
        updateCashFundAttributes(context, holdings);
        _.each(holdings, function (item) {
            var holding = {
                identifier: item.identifier,
                identifierType: item.identifierType,
                weight: item.weight,
                initial: item.initial || {},
                ongoing: item.ongoing || [{
                    name: 'Ongoing'
                }, {
                    name: 'Transaction'
                }, {
                    name: 'Performance'
                }]
            };
            newPortfolio.holdings.push(holding);
        });
        portfoliofeesSettings.portfolios.push(newPortfolio);

        return {
            parameters: formatIWTAPIParameters(context, portfolio),
            requestData: portfoliofeesSettings
        };
    }

    function formatIWTAPIParameters(context, portfolio) {
        var apiRunOption = 'RunInThread',
            portfolioDataPoints = [apiRunOption],
            holdingDataPoints = [apiRunOption],
            benchmarkDataPoints = [apiRunOption],
            apiDataPointsSchema = context.settings.get('apiDataPointsSchema') || [],
            apiDataPointsSchemaFields = context.settings.get('apiDataPointsSchemaFieldDefinitions') || {},
            hasBenchmark = isHasBenchmark(portfolio);
        morningstar.asterix.util.each(apiDataPointsSchema, function (item) {
            var data = apiDataPointsSchemaFields[item] || {};
            if (data.portfolioDataPoints) {
                portfolioDataPoints.push(data.portfolioDataPoints);
            }

            if (data.holdingDataPoints) {
                holdingDataPoints.push(data.holdingDataPoints);
            }

            if (data.benchmarkDataPoints && hasBenchmark) {
                benchmarkDataPoints.push(data.benchmarkDataPoints);
            }
        });

        return {
            portfolioDataPoints: _.uniq(portfolioDataPoints).join(),
            holdingDataPoints: _.uniq(holdingDataPoints).join(),
            benchmarkDataPoints: _.uniq(benchmarkDataPoints).join(),
            urlKey: context.settings.get('urlKey'),
            languageId: context.settings.get('languageId'),
            baseUrl: generateBaseUrl(context, 'EU')
        };
    }

    function formatIWTAPIRequestData(context, portfolio) {
        var holdings = portfolio.holdings || [],
            holdingType = editHoldingsHelper.generateHoldingType(holdings),
            holdingTypeValue;

        if (holdingType === 'amount') {
            holdingTypeValue = 3;
        } else if (holdingType === 'units') {
            holdingTypeValue = 9;
        } else {
            holdingTypeValue = 2;
        }

        updateCashFundAttributes(context, holdings);

        return JSON.stringify(JSON.stringify({
            type: holdingTypeValue,
            benchmarkId: morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio) || null,
            currencyId: portfolio.currencyId || context.settings.get('currencyId'),
            holdings: holdings
        }));
    }

    function generatePAAPIPortfolios(context, portfolio) {
        var portfolios = [];

        if (portfolio) {
            if (!portfolio.current && !portfolio.proposed) {
                portfolios.push(formatPortfolio(context, portfolio));
            } else {
                if (portfolio.current) {
                    portfolios.push(formatPortfolio(context, portfolio.current));
                }
                if (portfolio.proposed) {
                    portfolios.push(formatPortfolio(context, portfolio.proposed));
                }
            }
        }

        return portfolios;
    }

    function formatHolding(holding, holdingType) {
        var newHolding,
            identifierTypeMapping = morningstar.asterix.util.filter(inputDatapointMapping.identifierTypePAAPI, function (e) {
            return e.key === holding.identifierType.toLowerCase();
        });

        if (holdingType === 'weight') {
            newHolding = {
                Weight: holding.weight
            };
        } else if (holdingType === 'units') {
            newHolding = {
                units: holding.units
            };
        } else {
            newHolding = {
                Value: holding.amount
            };
        }

        if (identifierTypeMapping.length > 0) {
            newHolding[identifierTypeMapping[0].value] = holding.identifier;
        }

        return newHolding;
    }

    function formatPortfolio(context, portfolio) {
        var holdings = portfolio.holdings || [],
            benchmark = portfolio.benchmark,
            currencyId = portfolio.currencyId || context.settings.get('currencyId'),
            apiHoldings = [],
            apiBenchmark,
            holdingType = editHoldingsHelper.generateHoldingType(holdings);

        _.each(holdings, function (item) {
            apiHoldings.push(formatHolding(item, holdingType));
        });

        if (benchmark && benchmark.type) {
            if (benchmark.holdings && benchmark.holdings.length > 0) {
                apiBenchmark = {
                    Type: benchmark.type,
                    Holdings: []
                };
                _.each(benchmark.holdings, function (item) {
                    apiBenchmark.Holdings.push(formatHolding(item, 'weight'));
                });
            } else {
                apiBenchmark = {
                    Type: benchmark.type
                };
            }
        }

        return {
            Name: portfolio.name || 'Test Portfolio',
            TotalValue: portfolio.totalValue,
            Currency: currencyId,
            Holdings: apiHoldings,
            Benchmark: apiBenchmark
        };
    }

    function generateEditHoldings(context, editHoldings, portfolioType) {
        var portfolio = getPortfolio(context, portfolioType),
            holdingsType = editHoldingsHelper.generateHoldingType(portfolio.holdings),
            newEditHoldings = editHoldingsHelper.generateHoldings(editHoldings, holdingsType);

        updateCashFundAttributes(context, newEditHoldings);
        newEditHoldings.totalAmount = portfolio.totalValue;

        return newEditHoldings;
    }

    function updateCashFundAttributes(context, holdings) {
        var cashItem = _.find(holdings, function (item) {
            return item.identifier && item.identifier.toLowerCase().indexOf('cash') > -1;
        });
        if (cashItem) {
            cashItem.holdingTypeId = context.settings.get('cashHoldingTypeId');
            cashItem.securityType = context.settings.get('cashSecurityType');
        }
    }

    function generateBaseUrl(context, region) {
        if (morningstar.asterix.context.getToken('apiGatewayToken')) {
            return context.settings.get('baseUrlApiGateway' + region);
        } else {
            return context.settings.get('baseUrlMorningstar' + region);
        }
    }

    function handleIWTReturnData(context, retData, portfolioType) {
        // If there is no holdings in API input, just return empty object.
        var holdings = getPortfolio(context, portfolioType).holdings || [];
        if (holdings.length === 0) {
            return {};
        } else {
            return retData || {};
        }
    }

    function getPortfolio(context, portfolioType) {
        var portfolio = morningstar.asterix.extend(true, {}, morningstar.asterix.util.parse('parameters.portfolio')(context) || {});
        return portfolioType ? portfolio[portfolioType] || {} : portfolio;
    }

    function generatePAAPIUrlParameters(context) {
        var urlParameters = generateBaseUrlAndTokenParameters(context);
        urlParameters.languageId = context.settings.get('languageId');
        return urlParameters;
    }

    function getAssetClassGroupId(context) {
        var assetAllocationType = context.settings.get('assetAllocationType');
        return inputDatapointMapping.AssetClassGroupIdMapping[assetAllocationType] || assetAllocationType;
    }

    function generateBaseUrlAndTokenParameters(context) {
        var apiGatewayToken = morningstar.asterix.context.getToken('apiGatewayToken'),
            apiKey = morningstar.asterix.context.getToken('apiKey'),
            accessToken = morningstar.asterix.context.getToken('accessToken'),
            urlParameters = {};

        if (!(apiGatewayToken || apiKey || accessToken)) {
            context.instance.getLogger().fatal('Missing authentication key: apiGatewayToken or apiKey or accessToken.');
        }

        urlParameters.baseUrl = generateBaseUrl(context, 'US');
        if (apiGatewayToken) {
            urlParameters.apiTokenType = '';
            urlParameters.apiTokenValue = '';
        } else {
            if (accessToken) {
                urlParameters.apiTokenType = 'access_token';
                urlParameters.apiTokenValue = accessToken;
            } else if (apiKey) {
                urlParameters.apiTokenType = 'apikey';
                urlParameters.apiTokenValue = apiKey;
            }
        }
        return urlParameters;
    }

    function getBenchmarkId(portfolio) {
        return morningstar.asterix.util.parse('benchmarkId')(portfolio) || morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio);
    }

    function addAsOfDate(context, data, asOfDate) {
        if (data && asOfDate) {
            var returnDataSections = context.settings.get('returnDataSections') || [];
            var date = morningstar.asterix.util.date.convertToStandard(new Date(asOfDate));
            if (data && _.indexOf(returnDataSections, 'asOfDate') > -1) {
                _.each(data, function (value) {
                    if (_.isObject(value)) {
                        value.asOfDate = date;
                    }
                });
                data.asOfDate = date;
            }
        }
        return data;
    }

    function benchmarkHandlerOfUS(xray, securityReference, context, data, portfolioType) {
        if (!data) {
            return data;
        }
        // if there is no benchmark in API input, remove the response of benchmark from back end.
        var portfolio = getPortfolio(context, portfolioType);
        var hasBenchmark = isHasBenchmark(portfolio);
        if (!hasBenchmark) {
            _.each(data, function (value, key) {
                switch (key) {
                    case 'assetAllocation':
                    case 'feesExpenses':
                    case 'interestRateRisk':
                    case 'sectorsBreakdown':
                    case 'stockRegions':
                    case 'stockStatistics':
                        value.benchmark = {};
                        break;
                    case 'performanceChart':
                        removePerformanceChartBenchmark(data[key]);
                        break;
                    case 'trailingPerformance':
                        removeTrailingPerBenchmark(data[key]);
                        break;
                    default:
                        break;
                }
            });
        } else {
            var benchmarkId = morningstar.asterix.util.parse('PortfolioBenchmark.Holdings[0].SecurityId')(xray) || null;
            var benchmarkSecurity = _.find(securityReference, function (item) {
                return item.SecurityId === benchmarkId;
            }) || {};
            var benchmarkName = benchmarkSecurity.Name;

            data.benchmark = {
                benchmarkId: benchmarkId,
                benchmarkName: benchmarkName || null
            };
            //add benchmarkName to performanceChart
            if (benchmarkName) {
                var performanceChart = data.performanceChart;
                if (performanceChart) {
                    var benchmark = performanceChart.monthly.series[1];
                    benchmark.name = benchmarkName;
                    benchmark.useLabel = false;
                }
            }
        }
        return data;
    }

    function removePerformanceChartBenchmark(data) {
        if (data.monthly && data.monthly.series && data.monthly.series.length !== 0) {
            _.each(data.monthly.series, function (v) {
                if (v.name === 'benchmark') {
                    v.data = [];
                }
            });
        }
    }

    function removeTrailingPerBenchmark(data) {
        if (data && data.length !== 0) {
            _.each(data, function (v) {
                v.benchmark = null;
            });
        }
    }

    function isHasBenchmark(portfolio) {
        return morningstar.asterix.util.parse('benchmark.holdings[0].identifier')(portfolio) ? true : false;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    angular.module('ecPortfolioData', ['mstarCore']).directive('ecPortfolioData', portfolioData);

    function portfolioData() {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope);

            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    var usageTrackerHelper = {
        generateUsageTracker: generateUsageTracker,
        generateUsageTrackerForHoldings: generateUsageTrackerForHoldings
    };

    angular.module('ecPortfolioData').factory('portfolioDataUsageTrackerHelperService', function () {
        return usageTrackerHelper;
    });

    function getIdentifierWeightOrAmountVal(value) {
        var weightOrAmount = void 0,
            val = void 0;
        if (value.weight) {
            weightOrAmount = 'weight';
            val = value.weight;
        } else if (value.amount) {
            weightOrAmount = 'amount';
            val = value.amount;
        }
        return {
            weightOrAmount: weightOrAmount,
            val: val
        };
    }

    function getIdentifierWeightOrAmount(value) {
        var _getIdentifierWeightO = getIdentifierWeightOrAmountVal(value),
            weightOrAmount = _getIdentifierWeightO.weightOrAmount,
            val = _getIdentifierWeightO.val;

        return value.identifier + '|' + weightOrAmount + ':' + val;
    }

    function getUsageInfo(value) {
        var identifierWeightOrAmountList = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var v = _step.value;

                identifierWeightOrAmountList.push(getIdentifierWeightOrAmount(v));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return identifierWeightOrAmountList.join(', ');
    }

    function generateUsageTracker(hitObj, value) {
        if (!hitObj || !value) {
            return hitObj || {};
        }
        var usageInfo = void 0;
        if (_.isString(value)) {
            usageInfo = value;
        } else if (_.isArray(value)) {
            usageInfo = getUsageInfo(value);
        } else if (_.isObject(value)) {
            var holdings = value.holdings;
            if (holdings && holdings.length) {
                // generate pdf report, only recording holdings
                usageInfo = getUsageInfo(holdings);
            } else {
                usageInfo = getIdentifierWeightOrAmount(value);
            }
        }
        hitObj.value = usageInfo;
        return hitObj;
    }

    function generateUsageTrackerForHoldings(hitMap, newHoldings, oldHoldings, portfolioType) {
        var differenceHoldings,
            differenceIdentifiers,
            hitObj,
            newIdentifiers = _.map(newHoldings, function (holding) {
            return holding.identifier;
        }),
            oldIdentifiers = _.map(oldHoldings, function (holding) {
            return holding.identifier;
        });
        if (newHoldings.length === oldHoldings.length) {
            differenceIdentifiers = _.difference(newIdentifiers, oldIdentifiers);
            differenceHoldings = _.find(newHoldings, function (holding) {
                return holding.identifier === differenceIdentifiers[0];
            });

            hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentChanged' : 'investmentChanged')(hitMap), differenceHoldings);
        } else if (newHoldings.length > oldHoldings.length) {
            differenceIdentifiers = _.difference(newIdentifiers, oldIdentifiers);
            differenceHoldings = _.find(newHoldings, function (holding) {
                return holding.identifier === differenceIdentifiers[0];
            });
            hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentAdded' : 'investmentAdded')(hitMap), differenceHoldings);
        } else {
            differenceIdentifiers = _.difference(oldIdentifiers, newIdentifiers);
            differenceHoldings = _.find(oldHoldings, function (holding) {
                return holding.identifier === differenceIdentifiers[0];
            });
            hitObj = generateUsageTracker(morningstar.asterix.util.parse(portfolioType ? portfolioType + 'InvestmentRemoved' : 'investmentRemoved')(hitMap), differenceHoldings);
        }
        return hitObj;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromIwtFees', function (feesDatas) {
        return formatIwtfeesData(this.context, feesDatas);
    });

    function formatIwtfeesData(context, feesDatas) {
        feesDatas = feesDatas || [];

        var fromFeesData = {
            portfolioFeesSummary: generatePortfolioFeesSummaryModel(feesDatas[0]),
            holdingsFeesSummary: {
                holdings: generateHoldingsFeesSummaryModel(morningstar.asterix.util.parse('holdingFees')(feesDatas[0]))
            }
        };

        function findDataValue(datas, name, dataPoint) {
            var data = _.find(datas, function (item) {
                return item.name === name;
            }) || {};
            return data[dataPoint] || null;
        }

        function formatFeesValue(value, formatOptions) {
            var numberFormat = context.format.number;
            return numberFormat(value, formatOptions || 'shortDecimal');
        }

        function generatePortfolioFeesSummaryModel(portfolioFeesData) {
            portfolioFeesData = portfolioFeesData || {};
            var portfolioFees = {
                breakdown: []
            },
                summary = portfolioFeesData.summary || {},
                totalCosts = portfolioFeesData.totalCosts || {},
                initialCosts = portfolioFeesData.initialCosts || {},
                outputDataPoints = morningstar.asterix.util.parse('portfolioFees.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions')) || {};

            _.each(outputDataPoints, function (item) {
                portfolioFees.breakdown.push({
                    feesExpensesKey: item.key,
                    expenses: formatFeesValue(summary[item.key] || totalCosts[item.key] || initialCosts[item.key] || null, item.format)
                });
            });

            return portfolioFees;
        }

        function generateHoldingsFeesSummaryModel(holdingFeesData) {
            var holdingFees = [];
            _.each(holdingFeesData, function (data) {
                var recurringTotalBreakdown = morningstar.asterix.util.parse('breakdown.recurringTotal.breakdown')(data),
                    holdingFee = {
                    secId: data.secId || null,
                    name: data.name || null,
                    initialAmount: morningstar.asterix.util.parse('breakdown.initial.amount')(data) || null,
                    initialPercentage: morningstar.asterix.util.parse('breakdown.initial.percentage')(data) || null,
                    recurringFeeOngoingAmount: findDataValue(recurringTotalBreakdown, 'Ongoing', 'amount'),
                    recurringFeeOngoingPercentage: findDataValue(recurringTotalBreakdown, 'Ongoing', 'percentage'),
                    recurringFeeTransactionAmount: findDataValue(recurringTotalBreakdown, 'Transaction', 'amount'),
                    recurringFeeTransactionPercentage: findDataValue(recurringTotalBreakdown, 'Transaction', 'percentage'),
                    recurringFeePerformanceAmount: findDataValue(recurringTotalBreakdown, 'Performance', 'amount'),
                    recurringFeePerformancePercentage: findDataValue(recurringTotalBreakdown, 'Performance', 'percentage')
                };
                holdingFees.push(holdingFee);
            });
            return holdingFees;
        }

        return fromFeesData;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromIwtPortfolioComparisonReportInfo', function (parameters) {
        var reportPortfolios = [],
            context = this.context;

        _.each(['current', 'proposed'], function (portfolioType) {
            var postData = helper.generateIWTPostData(context, parameters, portfolioType) || {},
                requestData = JSON.parse(JSON.parse(postData.requestData));
            reportPortfolios.push({
                type: requestData.type,
                holdings: requestData.holdings,
                benchmarkId: requestData.benchmarkId,
                currencyId: requestData.currencyId
            });
        });

        return reportPortfolios;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(22)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromIwtXray', function (xrayData) {
        return formatIwtXrayData(this.context, xrayData);
    });

    morningstar.asterix.ng.transforms.register('fromIwtXrayCurrent', function (xrayData) {
        return formatIwtXrayData(this.context, xrayData, 'current');
    });

    morningstar.asterix.ng.transforms.register('fromIwtXrayProposed', function (xrayData) {
        return formatIwtXrayData(this.context, xrayData, 'proposed');
    });

    function formatIwtXrayData(context, xrayData, portfolioType) {
        if (!_.isObject(xrayData)) {
            xrayData = {};
        } else {
            xrayData = helper.handleIWTReturnData(context, xrayData, portfolioType);
        }

        var fromXrayData = {},
            returnDataSections = context.settings.get('returnDataSections'),
            holdingsData = getRawSectionData('holdings'),
            historicalPerformanceSeries = getRawSectionData('historicalPerformanceSeries');
        _.each(returnDataSections, function (section) {
            switch (section) {
                case 'assetAllocation':
                    var assetAllocationData = getRawSectionData('assetAllocation');
                    fromXrayData.assetAllocation = generateAssetAllocationModel(assetAllocationData);
                    break;
                case 'calendarYearsReturns':
                    fromXrayData.calendarYearsReturns = generateCalendarYearsReturnsModel(historicalPerformanceSeries, { timePeriod: 'M12', frequency: 'Annual' });
                    break;
                case 'correlationMatrix':
                    var correlationMatrixData = getRawSectionData('correlationMatrix');
                    fromXrayData.correlationMatrix = generateCorrelationMatrixModel(correlationMatrixData.breakdown, holdingsData.breakdown);
                    break;
                case 'creditQuality':
                    var creditQualityData = getRawSectionData('creditQuality');
                    fromXrayData.creditQuality = creditQualityData;
                    break;
                case 'editHoldings':
                    fromXrayData.editHoldings = generateEditHoldingsModel(holdingsData.breakdown, portfolioType);
                    break;
                case 'equityStyleBox':
                    var equityStyleBoxData = getRawSectionData('styleBox');
                    fromXrayData.equityStyleBox = generateStyleBoxModel(equityStyleBoxData.breakdown);
                    break;
                case 'feesExpenses':
                    var feesExpensesData = getRawSectionData('fees');
                    fromXrayData.feesExpenses = generateFeesExpensesModel(feesExpensesData.breakdown, dataPointMapping.feesExpenses);
                    break;
                case 'fixedIncomeStyleBox':
                    var fixedIncomeStyleBoxData = getRawSectionData('bondStyleBox');
                    fromXrayData.fixedIncomeStyleBox = generateStyleBoxModel(fixedIncomeStyleBoxData.breakdown);
                    break;
                case 'interestRateRisk':
                    var interestRateRiskData = getRawSectionData('bondStatistics');
                    fromXrayData.interestRateRisk = interestRateRiskData;
                    break;
                case 'performanceReturn':
                    var portfolio = portfolioType ? context.parameters.portfolio[portfolioType] : context.parameters.portfolio;
                    fromXrayData.performanceChart = generatePerformanceChartModel(historicalPerformanceSeries, {
                        portfolio: portfolio.name,
                        benchmark: xrayData.benchmarkName
                    });
                    break;
                case 'stockStats':
                    var stockStatisticsData = getRawSectionData('equityStatistics');
                    stockStatisticsData.benchmarkName = xrayData.benchmarkName;
                    fromXrayData.stockStatistics = stockStatisticsData;
                    break;
                case 'portfolioHoldings':
                    fromXrayData.holdings = generatePortfolioHoldingModel(holdingsData.breakdown, dataPointMapping.portfolioHoldings);
                    break;
                case 'quarterEndYearsReturns':
                    fromXrayData.quarterEndYearsReturns = generateQuarterEndYearsReturnsModel(historicalPerformanceSeries, xrayData.benchmarkName);
                    break;
                case 'riskRewardScatterplot':
                    var riskStatisticsData = getRawSectionData('riskStatistics');
                    fromXrayData.riskStatistics = generateRiskRewardScatterplotModel(riskStatisticsData, xrayData.holdings, xrayData.benchmarkName);
                    break;
                case 'stockOverlap':
                    var holdingOverlapData = getRawSectionData('holdingOverlap');
                    var underlyHoldings = getRawSectionData('underlyHoldings');
                    fromXrayData.stockOverlap = generateStockOverlapDataModel(holdingOverlapData.breakdown, underlyHoldings.breakdown, holdingsData.breakdown, dataPointMapping.stockOverlap);
                    break;
                case 'stockRegions':
                    var regionalExposureData = getRawSectionData('regionalExposure');
                    fromXrayData.stockRegions = regionalExposureData;
                    break;
                case 'stockSectors':
                    var stockSectorData = getRawSectionData('globalStockSector', true);
                    stockSectorData.benchmarkName = xrayData.benchmarkName;
                    fromXrayData.sectorsBreakdown = stockSectorData;
                    break;
                case 'timePeriodReturn':
                    fromXrayData.bestWorstPeriodData = morningstar.asterix.util.parse('bestWorstPeriods.returns')(xrayData) || [];
                    break;
                case 'trailingPerformance':
                    var trailingPerformanceData = getRawSectionData('trailingPerformance');
                    fromXrayData.trailingPerformance = generateTrailingPerformanceModel(trailingPerformanceData);
                    break;
                case 'riskStatistics':
                    fromXrayData.riskData = getRawSectionData('riskStatistics');
                    break;
                case 'riskScore':
                    fromXrayData.riskScore = {
                        score: morningstar.asterix.util.parse('portfolioRiskScore.portfolios[0].riskScore')(xrayData) || null
                    };
                    break;
                case 'topNetUnderlyingHoldings':
                    fromXrayData.topNetUnderlyingHoldings = getTopNetUnderlyingHoldings(context.settings);
                    break;
            }
        });

        fromXrayData.benchmark = {
            benchmarkId: xrayData.benchmarkId,
            benchmarkName: xrayData.benchmarkName
        };

        fromXrayData = helper.addAsOfDate(context, fromXrayData, morningstar.asterix.util.parse('trailingPerformance[0].endDate')(xrayData));

        function getTopNetUnderlyingHoldings(settings) {
            var underlyHoldings = xrayData.underlyHoldings || [];
            if (underlyHoldings.length) {
                underlyHoldings.sort(function (v1, v2) {
                    var w1 = v1.weight;
                    var w2 = v2.weight;
                    if (w1 > w2) {
                        return -1;
                    } else if (w1 < w2) {
                        return 1;
                    }
                    return 0;
                });
                var topNetUnderlyingHoldingsAmount = settings.get("defaultTopNetUnderlyingHoldingsAmount");
                return underlyHoldings.slice(0, topNetUnderlyingHoldingsAmount);
            }
        }

        function generateEditHoldingsModel(holdingsData, portfolioType) {
            var newHoldingsData = morningstar.asterix.extend(true, {}, holdingsData);
            _.each(newHoldingsData, function (holding) {
                holding.amount = holding.initialAmount;
                holding.identifier = holding.securityId;
            });
            return helper.generateEditHoldings(context, newHoldingsData, portfolioType);
        }

        function getRawSectionData(sectionName, modifyObject) {
            var data = {
                benchmark: null,
                breakdown: null
            };
            data.breakdown = morningstar.asterix.util.parse('breakdowns.' + sectionName)(xrayData) || xrayData[sectionName];
            var benchmarkArray = xrayData.benchmark || [];
            if (benchmarkArray.length > 0) {
                var benchmark = benchmarkArray[0];
                data.benchmark = benchmark[sectionName] || morningstar.asterix.util.parse('breakdowns.' + sectionName)(benchmark);
            }

            if (modifyObject) {
                data.portfolio = data.breakdown ? data.breakdown[0] : null;
                data.benchmark = data.benchmark ? data.benchmark[0] : null;
                delete data.breakdown;
            }
            return data;
        }

        function generateAssetAllocationModel(assetAllocationData) {
            var newAssetAllocationData = {
                benchmark: [],
                breakdown: []
            };
            var salePositions = ['N', 'L', 'S'],
                benchmark = assetAllocationData.benchmark || [],
                breakdown = assetAllocationData.breakdown || [],
                assetAllocationType = context.settings.get('assetAllocationType');
            _.each(salePositions, function (salePosition) {
                newAssetAllocationData.benchmark.push(generateAssetAllocationValues(salePosition, assetAllocationType, benchmark));
                newAssetAllocationData.breakdown.push(generateAssetAllocationValues(salePosition, assetAllocationType, breakdown));
            });

            return newAssetAllocationData;
        }

        function generateAssetAllocationValues(salePosition, assetAllocationType, data) {
            return _.findWhere(data, {
                salePosition: salePosition,
                type: assetAllocationType
            }) || {
                salePosition: salePosition,
                type: assetAllocationType,
                values: {}
            };
        }

        function generateStyleBoxModel(styleBoxData) {
            if (styleBoxData) {
                styleBoxData = _.toArray(styleBoxData[0].values);
                styleBoxData.pop();
            }
            var newData = styleBoxData || [];
            for (var index = newData.length; index < 9; ++index) {
                newData.push(0);
            }
            return newData;
        }

        function generatePortfolioHoldingModel(holdings) {
            var newHoldings = [];
            morningstar.asterix.util.each(holdings, function (holding) {
                var holdingObject = {
                    isinMic: holding.iSIN && holding.exchangeCode ? holding.iSIN + String('XXXX' + holding.exchangeCode).slice(-4) : null
                };

                morningstar.asterix.util.each(holding, function (value, key) {
                    if (!morningstar.asterix.util.isObject(value)) {
                        holdingObject[key] = value;
                    }
                });

                var trailingPerformance = holding.trailingPerformance || [],
                    trailingPerformanceReturns = trailingPerformance.length > 0 ? holding.trailingPerformance[0].returns : [];
                _.each(trailingPerformanceReturns, function (data) {
                    holdingObject['trailingReturn' + data.timePeriod] = data.value;
                });

                newHoldings.push(holdingObject);
            });

            return newHoldings;
        }

        function generateFeesExpensesModel(fees, keyMap) {
            var mockModel = {
                Percent: 0,
                breakdown: [],
                Portfolio: morningstar.asterix.util.parse('ongoingCharge.value')(fees) || null
            },
                outputDataPoints = morningstar.asterix.util.parse('feesExpenses.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions'));
            _.each(outputDataPoints, function (key) {
                mockModel.breakdown.push({
                    feesExpensesKey: key,
                    expenses: morningstar.asterix.util.parse(key + '.value')(fees) || null
                });
            });
            return mockModel;
        }

        function transformPerformanceChartData(dataArr) {
            var transformedArr = [];

            _.each(dataArr, function (arrObj) {
                var transformedObj = {};
                transformedObj.endDate = morningstar.asterix.util.date.toLocalISOString(new Date(arrObj[0]));
                transformedObj.value = arrObj[1];
                transformedArr.push(transformedObj);
            });
            return transformedArr;
        }

        function generatePerformanceChartModel(historicalPerformanceSeries, name) {
            var mockModel = {
                monthly: {
                    series: [{
                        name: name.portfolio || 'portfolio',
                        useLabel: name.portfolio ? false : true
                    }, {
                        name: name.benchmark || 'benchmark',
                        useLabel: name.benchmark ? false : true
                    }]
                }
            },
                portfolio = _.findWhere(historicalPerformanceSeries.breakdown, { timePeriod: 'M1' }) || {},
                benchmark = _.findWhere(historicalPerformanceSeries.benchmark, { timePeriod: 'M1' }) || {};

            mockModel.monthly.series[0].data = portfolio ? transformPerformanceChartData(portfolio.returns) : [];
            mockModel.monthly.series[1].data = benchmark ? transformPerformanceChartData(benchmark.returns) : [];

            return mockModel;
        }

        function generateRiskRewardScatterplotModel(riskStatisticsData, holdings, benchmarkName) {
            if (!riskStatisticsData && !holdings) {
                context.instance.getLogger().warn('There is no risk statistics data.');
                return null;
            }
            var riskStatisticsModel = {
                holdingsRiskStatistics: []
            };
            _.each(holdings, function (item) {
                if (item.riskStatistics) {
                    riskStatisticsModel.holdingsRiskStatistics.push({
                        name: item.name,
                        weight: item.weight,
                        riskStatistics: changeRiskStatisticsTimePeriod(item.riskStatistics)
                    });
                }
            });
            if (riskStatisticsData.benchmark) {
                riskStatisticsModel.benchmarkRiskStatistics = {
                    name: benchmarkName,
                    weight: 100,
                    riskStatistics: changeRiskStatisticsTimePeriod(riskStatisticsData.benchmark)
                };
            }
            if (riskStatisticsData.breakdown) {
                riskStatisticsModel.portfolioRiskStatistics = {
                    name: 'Portfolio',
                    weight: 100,
                    riskStatistics: changeRiskStatisticsTimePeriod(riskStatisticsData.breakdown)
                };
            }
            return riskStatisticsModel;
        }

        function changeRiskStatisticsTimePeriod(riskStatisticsData) {
            _.each(riskStatisticsData.arithmeticMean, function (item) {
                if (item.timePeriod === 'M12') {
                    item.timePeriod = 'Year1';
                } else if (item.timePeriod === 'M36') {
                    item.timePeriod = 'Year3';
                } else if (item.timePeriod === 'M60') {
                    item.timePeriod = 'Year5';
                } else if (item.timePeriod === 'M120') {
                    item.timePeriod = 'Year10';
                }
            });
            _.each(riskStatisticsData.standardDeviation, function (item) {
                if (item.timePeriod === 'M12') {
                    item.timePeriod = 'Year1';
                } else if (item.timePeriod === 'M36') {
                    item.timePeriod = 'Year3';
                } else if (item.timePeriod === 'M60') {
                    item.timePeriod = 'Year5';
                } else if (item.timePeriod === 'M120') {
                    item.timePeriod = 'Year10';
                }
            });
            return riskStatisticsData;
        }

        function generateStockOverlapDataModel(overlapHoldings, underlyHoldings, portfolioHoldings, keyMap) {
            var newStockOverlap = [];
            if (portfolioHoldings && overlapHoldings) {
                var stockHoldingDatas = _.filter(overlapHoldings, function (item) {
                    return item.securityType === 'E';
                });

                _.each(stockHoldingDatas, function (stockHoldingData) {
                    var sectorKey = null;
                    if (stockHoldingData.globalSectorId) {
                        sectorKey = stockHoldingData.globalSectorId ? keyMap[stockHoldingData.globalSectorId] : null;
                    }

                    var symbolData = _.find(underlyHoldings, function (holding) {
                        return holding.holdingId === stockHoldingData.holdingId;
                    }) || {};

                    var stockOverlapObject = {
                        securityName: stockHoldingData.name,
                        symbol: symbolData.symbol,
                        percentOfInvestments: stockHoldingData.weight,
                        sector: context.labels.get(sectorKey),
                        type: stockHoldingData.securityType ? 'st' : null,
                        securityId: stockHoldingData.securityId,
                        holdingData: []
                    };

                    _.each(stockHoldingData.parentHoldings, function (parentHolding) {
                        var stockOverlapParentData = _.find(portfolioHoldings, function (portfolioHolding) {
                            var holdingId = portfolioHolding.holdingId + '';
                            return holdingId === parentHolding.holdingId;
                        }) || {};

                        var stockOverlapParentObject = {
                            securityName: stockOverlapParentData.name,
                            symbol: stockOverlapParentData.symbol,
                            percentOfInvestments: parentHolding.weight,
                            holdingPortfolioDate: stockOverlapParentData.portfolioDate,
                            sector: stockOverlapParentData.sectorName,
                            type: stockOverlapParentData.securityType && stockOverlapParentData.securityType.toLowerCase(),
                            securityId: stockOverlapParentData.securityId
                        };
                        stockOverlapObject.holdingData.push(stockOverlapParentObject);
                    });

                    newStockOverlap.push(stockOverlapObject);
                });
            }
            return newStockOverlap;
        }

        function generateTrailingPerformanceModel(trailingPerformanceData) {
            var returnTrailingPerformanceData = [],
                portfolio = morningstar.asterix.util.parse('breakdown[0].returns')(trailingPerformanceData),
                benchmark = morningstar.asterix.util.parse('benchmark[0].returns')(trailingPerformanceData);

            _.each(portfolio, function (item) {
                var obj = {
                    timePeriod: item.timePeriod,
                    portfolio: item.value
                };

                var returnData = _.find(benchmark, function (data) {
                    return data.timePeriod === item.timePeriod;
                }) || {};
                obj.benchmark = returnData.value;

                returnTrailingPerformanceData.push(obj);
            });

            return returnTrailingPerformanceData;
        }

        function generateCorrelationMatrixModel(correlationMatrix, holdings) {
            if (!correlationMatrix || !correlationMatrix.length) {
                context.instance.getLogger().warn('There is no correlation matrix data.');
                return null;
            }
            var newCorrelationMatrix = {
                timePeriod: correlationMatrix[0].timePeriod,
                endDate: correlationMatrix[0].endDate,
                correlationMatrixDetail: []
            };
            _.each(holdings, function (holdingsItem) {
                var correlationMatrixDetailItem = _.find(correlationMatrix[0].correlationMatrixDetail, function (item) {
                    return item.id === holdingsItem.holdingId.toString();
                });
                /**
                 * if correlationMatrixDetailItem or its correlationDetail is not exist,
                 * mock up a fake data
                 */
                if (!correlationMatrixDetailItem || !correlationMatrixDetailItem.correlationDetail) {
                    var correlationDetail = [];
                    for (var i = 0; i < holdings.length; i++) {
                        var correlationItem = {
                            id: i.toString(),
                            correlation: ''
                        };
                        correlationDetail.push(correlationItem);
                    }
                    correlationMatrixDetailItem = {
                        id: holdingsItem.holdingId.toString(),
                        correlationDetail: correlationDetail
                    };
                } else {
                    var newCorrelationDetail = [];
                    _.each(holdings, function (newHoldingsItem) {
                        var correlationDetailItem = _.find(correlationMatrixDetailItem.correlationDetail, function (item) {
                            return item.id === newHoldingsItem.holdingId.toString();
                        });
                        /**
                         * if correlationDetailItem or its correlationDetail is not exist,
                         * mock up a fake data
                         */
                        if (!correlationDetailItem || !correlationDetailItem.correlation) {
                            correlationDetailItem = {
                                id: newHoldingsItem.holdingId.toString(),
                                correlation: ''
                            };
                        }
                        newCorrelationDetail.push(correlationDetailItem);
                    });
                    correlationMatrixDetailItem.correlationDetail = newCorrelationDetail;
                }
                correlationMatrixDetailItem.name = holdingsItem.name || '';
                newCorrelationMatrix.correlationMatrixDetail.push(correlationMatrixDetailItem);
            });
            return newCorrelationMatrix;
        }

        function generateQuarterEndYearsReturnsModel(historicalPerformanceSeries, benchmarkName) {
            var data = generateCalendarYearsReturnsModel(historicalPerformanceSeries, { timePeriod: 'M12', frequency: 'TrailingAnnual' }) || [];
            var quarterEndYearsReturnsModel = {
                benchmark: [{ content: benchmarkName, fieldName: 'benchmark', indicatorLabelKey: 'benchmarkName' }],
                data: data.reverse()
            };
            return quarterEndYearsReturnsModel;
        }

        function generateCalendarYearsReturnsModel(historicalPerformanceSeries, filter) {
            var calendarYearsReturns = [],
                portfolio = _.findWhere(historicalPerformanceSeries.breakdown, filter) || {},
                benchmark = _.findWhere(historicalPerformanceSeries.benchmark, filter) || {},
                portfolioReturns = portfolio.returns || [],
                benchmarkReturns = benchmark.returns || [],
                maxNoOfCalendarYearsReturns = Math.min(portfolioReturns.length, context.settings.get('maxNoOfCalendarYearsReturns')),
                numberOfYearsReturns = context.settings.get('numberOfYearsReturns'),
                returnEndDate = portfolio.endDate ? portfolio.endDate : morningstar.asterix.util.date.addMonths(new Date(), -12 * numberOfYearsReturns).toISOString();

            for (var index = 1; index <= maxNoOfCalendarYearsReturns; ++index) {
                var returnData = portfolioReturns[portfolioReturns.length - index] || [];
                if (returnData.length > 1) {
                    calendarYearsReturns.push({
                        name: context.labels.get('returnM12_' + index),
                        endDate: returnData[0],
                        startDate: morningstar.asterix.util.date.addMonths(new Date(returnData[0]), -12).toISOString(),
                        portfolio: returnData[1],
                        benchmark: generateCalendarYearsBenchmarkReturns(benchmarkReturns, new Date(returnData[0]))
                    });
                }
            }
            if (numberOfYearsReturns > 0 && numberOfYearsReturns > portfolioReturns.length) {
                var startIndex = portfolioReturns.length + 1;
                for (var i = startIndex; i <= numberOfYearsReturns; ++i) {
                    var endDate = morningstar.asterix.util.date.addMonths(new Date(returnEndDate), -12 * (i - 1));
                    calendarYearsReturns.push({
                        name: context.labels.get('returnM12_' + i),
                        endDate: endDate,
                        startDate: morningstar.asterix.util.date.addMonths(new Date(returnEndDate), -12 * i).toISOString(),
                        portfolio: null,
                        benchmark: generateCalendarYearsBenchmarkReturns(benchmarkReturns, endDate)
                    });
                }
            }
            return calendarYearsReturns;
        }

        function generateCalendarYearsBenchmarkReturns(benchmarkReturns, endDate) {
            var benchmark = _.find(benchmarkReturns, function (data) {
                return data && new Date(data[0]).getTime() === endDate.getTime();
            }) || [];

            return benchmark[1];
        }

        return fromXrayData;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPAAPIHypo', function (hypoData) {
        hypoData = hypoData || {};

        var fromHypoData = {
            originalData: hypoData
        },
            context = this.context,
            hypos = hypoData.Hypo || [],
            securities = hypoData.SecurityReference || [],
            subsequentInvestmentType = context.parameters.hypotheticalSettings.subsequentInvestmentType || 'Invest',
            initialInvestmentAmount = context.parameters.hypotheticalSettings.initialInvestmentAmount || 10000,
            returnDataSections = context.settings.get('returnDataSections');

        _.each(returnDataSections, function (section) {
            switch (section) {
                case 'hypotheticalGrowth':
                    fromHypoData.performanceChart = generatePerformanceModel(hypos, securities);
                    break;
                case 'hypoDates':
                    fromHypoData.hypoDates = {
                        asOfDate: morningstar.asterix.util.date.toUTCLocalISOString(morningstar.asterix.util.date.getMonthEndDate(morningstar.asterix.util.date.addMonths(new Date(), -1))),
                        earliestAvailableDate: morningstar.asterix.util.parse('PerformanceDate.EarliestAvailableDate')(hypos[0]),
                        earliestCommonDate: morningstar.asterix.util.parse('PerformanceDate.EarliestCommonDate')(hypos[0]),
                        sinceInceptionDate: morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(hypos[0])
                    };
                    break;
                case 'portfolio':
                    fromHypoData.portfolio = helper.generatePAAPIPortfolios(context, context.parameters.portfolio);
                    break;
                case 'hypotheticalGrowthTable':
                    fromHypoData.hypotheticalGrowthTable = generateHypotheticalGrowthTableModel(hypos);
                    break;
            }
        });
        return fromHypoData;

        function generatePerformanceModel(hypoDataArray, securities) {
            var mockModel = { series: [] },
                benchmarkId = morningstar.asterix.util.parse('parameters.portfolio.benchmark.holdings[0].identifier')(context) || morningstar.asterix.util.parse('parameters.portfolio.current.benchmark.holdings[0].identifier')(context) || morningstar.asterix.util.parse('parameters.portfolio.proposed.benchmark.holdings[0].identifier')(context);

            if (hypoDataArray.length !== 0) {
                _.each(hypoDataArray, function (hypoData) {
                    var portfolio = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryChart.Portfolio')(hypoData) || {};
                    mockModel.series.push({
                        name: hypoData.PortfolioName || 'portfolio',
                        useLabel: hypoData.PortfolioName ? false : true,
                        data: transformPerformanceData(portfolio)
                    });
                    if (benchmarkId) {
                        var benchmark = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryChart.Benchmark')(hypoData) || {};
                        var benchmarkSecurity = _.findWhere(securities, { SecurityId: benchmarkId }) || {};
                        mockModel.series.push({
                            name: benchmarkSecurity.Name || 'benchmark',
                            useLabel: benchmarkSecurity.Name ? false : true,
                            data: transformPerformanceData(benchmark)
                        });
                    }
                });
            } else {
                mockModel.series = [{
                    name: 'portfolio',
                    useLabel: true,
                    data: []
                }];
            }
            return mockModel;
        }

        /** direct use market value */
        function transformPerformanceData(performanceData) {
            if (morningstar.asterix.util.isEmptyObject(performanceData)) {
                return [];
            }
            var chartData = [],
                startDate = performanceData.StartDate,
                //API return ISO string without Z  e.g. 2001-08-24T00:00:00
            asOfDate = morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(hypos[0]),
                monthEndDate = morningstar.asterix.util.date.getMonthEndDate(new Date(startDate)),
                startDateIsMonthEnd = new Date(startDate).getDate() === monthEndDate.getDate();
            _.each(performanceData.Data, function (item, index) {
                var value, newDate, newMonthEndDate, chartDateStr;
                value = item.Value;
                if (index > 0) {
                    newDate = morningstar.asterix.util.date.addMonths(new Date(startDate), startDateIsMonthEnd ? index : index - 1);
                    newMonthEndDate = morningstar.asterix.util.date.getMonthEndDate(newDate);
                    chartDateStr = newMonthEndDate < new Date(asOfDate) ? morningstar.asterix.util.date.toUTCLocalISOString(newMonthEndDate) : asOfDate;
                } else {
                    chartDateStr = startDate;
                }
                chartData.push({ date: chartDateStr, close: value });
            });
            return chartData;
        }

        function generateHypotheticalGrowthTableModel(hypoData) {
            var tableData = [];
            _.each(hypoData, function (item) {
                var totalWithdrawal = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalDistributionAndWithdrawal')(item) || 0,
                    totalNewInvestment = morningstar.asterix.util.parse('PortfolioSummary.InvestmentDetails.PortfolioTotalNewInvestment')(item) || initialInvestmentAmount,
                    finalMarketValue = morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.FinalMarketValue')(item) || 0,
                    totalContributionAmounts = totalNewInvestment,
                    totalGain = 0;
                if (subsequentInvestmentType.toLowerCase() === 'withdrawal') {
                    totalGain = finalMarketValue - initialInvestmentAmount + totalWithdrawal;
                } else {
                    totalGain = finalMarketValue - totalNewInvestment;
                }
                tableData.push({
                    name: item.PortfolioName,
                    asOfDate: morningstar.asterix.util.parse('PortfolioSummary.AsOfDate')(item) || '',
                    totalContributionAmounts: totalContributionAmounts,
                    marketValue: finalMarketValue,
                    totalGain: totalGain,
                    cumulativeReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.CumulativeReturn')(item) || 0,
                    avgAnnualizedReturn: morningstar.asterix.util.parse('PortfolioSummary.PortfolioSummaryPerformance.AverageAnnualizedReturn')(item) || 0,
                    inceptionDate: morningstar.asterix.util.parse('PerformanceDate.EarliestInceptionDate')(item) || '',
                    initialInvestmentAmount: initialInvestmentAmount
                });
            });
            return tableData;
        }
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPAAPIPerformance', function (performanceData) {
        performanceData = performanceData || {};

        var fromPerformanceData = {},
            context = this.context,
            parameters = this.context.parameters,
            benchmark = morningstar.asterix.util.parse('portfolio.benchmark.holdings')(parameters),
            benchmarkId = benchmark.length > 0 ? benchmark[0].identifier : null,
            performance = performanceData.Performance && performanceData.Performance[0] || {},
            securityReference = performanceData.SecurityReference || [],
            RiskStatistics = morningstar.asterix.util.parse('Risks.RiskStatistics')(performance) || [],
            returnDataSections = context.settings.get('returnDataSections');

        _.each(returnDataSections, function (section) {
            switch (section) {
                case 'riskRewardScatterplot':
                    fromPerformanceData.riskStatistics = generateRiskStatisticsModel(RiskStatistics, benchmarkId, securityReference);
                    break;
            }
        });

        return fromPerformanceData;

        function generateRiskStatisticsModel(riskStatisticsData, benchmarkId, securityReference) {
            if (!riskStatisticsData || !riskStatisticsData.length) {
                return null;
            }
            var benchmarkData = _.find(securityReference, function (item) {
                return item.SecurityId === benchmarkId;
            });
            var benchmarkName = null;
            if (benchmarkData) {
                benchmarkName = benchmarkData.Name ? benchmarkData.Name : null;
            }
            var mockModel = {
                holdingsRiskStatistics: []
            };
            var securityIdArr = [];
            _.each(riskStatisticsData, function (item) {
                _.each(item.Security, function (securityItem) {
                    var securityId = _.find(securityIdArr, function (arrayItem) {
                        return securityItem.SecurityId === arrayItem.securityId;
                    });
                    if (!securityId) {
                        securityIdArr.push({
                            securityId: securityItem.SecurityId,
                            weight: securityItem.Weight
                        });
                    }
                });
            });
            _.each(securityIdArr, function (securityItem) {
                var security = _.find(securityReference, function (item) {
                    return item.SecurityId === securityItem.securityId;
                });
                var holdingRiskStatisticsItem;
                if (security) {
                    holdingRiskStatisticsItem = {
                        name: security.Name ? security.Name : null,
                        weight: securityItem.weight,
                        riskStatistics: transformRiskStatisticsModel('Holdings', riskStatisticsData, securityItem.securityId)
                    };
                    mockModel.holdingsRiskStatistics.push(holdingRiskStatisticsItem);
                }
            });
            mockModel.benchmarkRiskStatistics = {
                name: benchmarkName,
                weight: 100,
                riskStatistics: transformRiskStatisticsModel('Benchmark', riskStatisticsData)
            };
            mockModel.portfolioRiskStatistics = {
                name: 'Portfolio',
                weight: 100,
                riskStatistics: transformRiskStatisticsModel('Portfolio', riskStatisticsData)
            };
            return mockModel;
        }

        function transformRiskStatisticsModel(type, riskStatisticsData, holdingId) {
            var riskStatisticsModel = {
                arithmeticMean: [],
                standardDeviation: []
            };
            _.each(riskStatisticsData, function (item) {
                var meanItem, standardDeviationItem;
                var valueName;

                if (type === 'Benchmark') {
                    valueName = item.Benchmark;
                } else if (type === 'Holdings') {
                    var security = _.find(item.Security, function (securityItem) {
                        return securityItem.SecurityId === holdingId;
                    });
                    valueName = security.RiskStatisticsItem || {};
                } else if (type === 'Portfolio') {
                    valueName = item.Portfolio;
                }
                meanItem = {
                    timePeriod: item.TrailingTimePeriod || null,
                    frequency: item.DataFrequency || null,
                    value: valueName.Mean || null
                };
                standardDeviationItem = {
                    timePeriod: item.TrailingTimePeriod || null,
                    frequency: item.DataFrequency || null,
                    value: valueName.StandardDeviation || null
                };
                riskStatisticsModel.arithmeticMean.push(meanItem);
                riskStatisticsModel.standardDeviation.push(standardDeviationItem);
            });
            return riskStatisticsModel;
        }
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPAAPI', function (xrayData) {
        xrayData = xrayData || {};
        var fromXrayData = {},
            context = this.context,
            xrays = xrayData.XRay || [],
            hasCurrent = !_.isUndefined(context.parameters.portfolio.current),
            hasProposed = !_.isUndefined(context.parameters.portfolio.proposed);

        if (!hasCurrent && !hasProposed) {
            fromXrayData = generateXrayData(xrayData.SecurityReference, xrays[0]);
        } else {
            if (hasCurrent && hasProposed) {
                fromXrayData.current = generateXrayData(xrayData.SecurityReference, xrays[0], 'current');
                fromXrayData.proposed = generateXrayData(xrayData.SecurityReference, xrays[1], 'proposed');
            } else {
                var retData = generateXrayData(xrayData.SecurityReference, xrays[0], hasCurrent ? 'current' : 'proposed');
                if (hasCurrent) {
                    fromXrayData.current = retData;
                    fromXrayData.proposed = context.instance.model.securities.proposed;
                } else {
                    fromXrayData.proposed = retData;
                    fromXrayData.current = context.instance.model.securities.current;
                }
            }
        }

        function generateXrayData(securityReference, xray, portfolioType) {
            xray = xray || {};

            var retData = {},
                returnDataSections = context.settings.get('returnDataSections');

            _.each(returnDataSections, function (section) {
                switch (section) {
                    case 'assetAllocation':
                        retData.assetAllocation = generateAssetAllocationModel(xray, dataPointMapping.assetAllocation);
                        break;
                    case 'creditQuality':
                        retData.creditQuality = generateCreditQualityModel(xray, dataPointMapping.creditQuality);
                        break;
                    case 'editHoldings':
                        retData.editHoldings = generateEditHoldingsModel(securityReference, xray, portfolioType);
                        break;
                    case 'equityStyleBox':
                        retData.equityStyleBox = generateEquityStyleBoxModel(xray);
                        break;
                    case 'feesExpenses':
                        retData.feesExpenses = generateFeeExpensesModel(xray, dataPointMapping.feesExpenses);
                        break;
                    case 'fixedIncomeStyleBox':
                        retData.fixedIncomeStyleBox = generateFixedIncomeStyleBoxModel(xray);
                        break;
                    case 'interestRateRisk':
                        retData.interestRateRisk = generateInterestRateRiskModel(xray, dataPointMapping.bondStatistics);
                        break;
                    case 'performanceReturn':
                        var portfolio = portfolioType ? context.parameters.portfolio[portfolioType] : context.parameters.portfolio;
                        retData.performanceChart = generatePerformanceChartModel(xray, portfolio.name);
                        break;
                    case 'stockStats':
                        retData.stockStatistics = generateStockStatsModel(xray, dataPointMapping.equityStatistics);
                        break;
                    case 'portfolioHoldings':
                        retData.holdings = generatePortfolioHoldingModel(securityReference, xray);
                        break;
                    case 'stockOverlap':
                        retData.stockOverlap = generateStockOverlapModel(securityReference, xray, dataPointMapping.stockSectors);
                        break;
                    case 'stockRegions':
                        retData.stockRegions = generateRegionsModel(xray, dataPointMapping.regionalExposure);
                        break;
                    case 'stockSectors':
                        retData.sectorsBreakdown = generateSectorModel(xray, dataPointMapping.globalStockSectors);
                        break;
                    case 'trailingPerformance':
                        retData.trailingPerformance = generateTrailingPerformanceModel(xray);
                        break;
                    case 'topNetUnderlyingHoldings':
                        retData.topNetUnderlyingHoldings = generateTopNetUnderlyingHoldingsModel(securityReference, xray);
                        break;

                }
            });
            retData = helper.benchmarkHandlerOfUS(xray, securityReference, context, retData, portfolioType);

            retData = helper.addAsOfDate(context, retData, morningstar.asterix.util.parse('Statistics.PortfolioSummary.PortfolioDate')(xray));

            return retData;
        }

        function generateEditHoldingsModel(securityReference, xray, portfolioType) {
            var securities = morningstar.asterix.util.parse('Holdings.PortfolioHoldings.Security')(xray) || [];
            var holdings = [];
            _.each(securities, function (security) {
                var data = _.find(securityReference, function (item) {
                    if (item.SecurityId === security.SecurityId) {
                        return item;
                    }
                });
                holdings.push({
                    identifier: security.SecurityId,
                    securityType: data && data.Type || null,
                    name: data && data.Name || null,
                    units: security.Units || null,
                    weight: security.PercentAssets,
                    amount: security.MarketValue
                });
            });
            return helper.generateEditHoldings(context, holdings, portfolioType);
        }

        function generateAssetAllocationModel(xray, keyMap) {
            var assetAllocationModel = {
                benchmark: [],
                breakdown: []
            },
                assetAllocationArr = morningstar.asterix.util.parse('Analysis.AssetAllocation')(xray) || [],
                assetAllocation = assetAllocationArr.length > 0 ? assetAllocationArr[0] : {},
                assetAllocationID = assetAllocation.Id,
                benchmark = morningstar.asterix.util.parse('Benchmark')(assetAllocation) || [],
                portfolio = morningstar.asterix.util.parse('Portfolio')(assetAllocation) || [],
                assetAllocationGroupMappingId = morningstar.asterix.util.parse('idMap.' + assetAllocationID)(keyMap) || 'MorningstarUSA',
                assetAllocationElementModel = {
                type: assetAllocationGroupMappingId,
                salePosition: '',
                values: {}
            };

            var salePositions = ['N', 'L', 'S'],
                assetAllocationMap = keyMap[assetAllocationGroupMappingId];
            _.each(salePositions, function (salePosition) {
                var portfolioAssetAllocation = generateAssetAllocationModelForSalePosition(assetAllocationElementModel, portfolio, assetAllocationMap, salePosition),
                    benchmarkAssetAllocation = generateAssetAllocationModelForSalePosition(assetAllocationElementModel, benchmark, assetAllocationMap, salePosition);
                assetAllocationModel.benchmark.push(benchmarkAssetAllocation);
                assetAllocationModel.breakdown.push(portfolioAssetAllocation);
            });
            return assetAllocationModel;
        }

        function generateAssetAllocationModelForSalePosition(assetAllocationElementModel, portfolio, assetAllocationMap, salePosition) {
            assetAllocationElementModel = JSON.parse(JSON.stringify(assetAllocationElementModel));
            var apiSalePositionName;

            if (salePosition === 'N') {
                apiSalePositionName = 'Net';
            } else if (salePosition === 'L') {
                apiSalePositionName = 'Long';
            } else if (salePosition === 'S') {
                apiSalePositionName = 'Short';
            }

            _.each(portfolio, function (dataElementFromAPI) {
                assetAllocationElementModel.salePosition = salePosition;
                var mappedIdForAsset = assetAllocationMap[dataElementFromAPI.Id];
                assetAllocationElementModel.values[mappedIdForAsset] = dataElementFromAPI[apiSalePositionName];
            });

            return assetAllocationElementModel;
        }

        function generateCreditQualityModel(xray, keyMap) {
            var mockModel = {
                breakdown: []
            };
            var values = {};
            var portfolio = morningstar.asterix.util.parse('Analysis.FixedIncomeAnalysis.CreditQuality.Portfolio')(xray) || {};

            _.each(portfolio, function (value, key) {
                if (keyMap[key]) {
                    values[keyMap[key]] = value;
                }
            });

            mockModel.breakdown.push({ values: values });
            return mockModel;
        }

        function generateEquityStyleBoxModel(xRay) {
            var styleBoxData = morningstar.asterix.util.parse('Analysis.InvestmentStyle.EquityStyle.EquityStyleBreakdown.Portfolio')(xRay) || {};
            return generateStyleBoxModel(styleBoxData, 0, 9);
        }

        function generateFeeExpensesModel(xRay, keyMap) {
            var feeExpensesModel = {
                category: null,
                benchmark: null,
                breakdown: [],
                portfolio: null
            },
                portfolio = morningstar.asterix.util.parse('Statistics.FundStatistics.Portfolio')(xRay) || {},
                outputDataPoints = morningstar.asterix.util.parse('feesExpenses.outputDataPoints')(context.settings.get('apiDataPointsSchemaFieldDefinitions'));
            _.each(outputDataPoints, function (key) {
                feeExpensesModel.breakdown.push({
                    expenses: portfolio[key] || null,
                    feesExpensesKey: morningstar.asterix.util.string.firstLowerCase(key)
                });
            });

            return feeExpensesModel;
        }

        function generateFixedIncomeStyleBoxModel(xray) {
            var styleBoxData = morningstar.asterix.util.parse('Analysis.InvestmentStyle.FixedIncomeStyle.FixedIncomeStyleBreakdown')(xray) || {};
            return generateStyleBoxModel(styleBoxData, 1, 10);
        }

        function generateInterestRateRiskModel(xray, keyMap) {
            var mockModel = {
                breakdown: {},
                benchmark: {}
            };
            var interestRateRisk = morningstar.asterix.util.parse('Analysis.FixedIncomeAnalysis.InterestRateRisk')(xray) || {};
            var portfolio = interestRateRisk.Portfolio || {};
            var benchmark = interestRateRisk.Benchmark || {};

            _.each(keyMap, function (item, name) {
                var breakdownItem = mockModel.breakdown[name] = {},
                    benchmarkItem = mockModel.benchmark[name] = {};

                breakdownItem.value = portfolio[item] || null;
                benchmarkItem.value = benchmark[item] || null;
            });

            return mockModel;
        }

        function generateTopNetUnderlyingHoldingsModel(securityReference, xray) {
            var mockModel = [];
            var securities = morningstar.asterix.util.parse('Holdings.TopNetUnderlyingHoldings.Security')(xray) || [];
            _.each(securities, function (security) {
                var securityData = _.find(securityReference, function (item) {
                    if (item.SecurityId === security.SecurityId) {
                        return item;
                    }
                }) || {};
                var newSecurity = {
                    weight: security.PercentAssets,
                    sector: security.EquitySector ? context.labels.get(morningstar.asterix.util.string.firstLowerCase(security.EquitySector)) : null,
                    name: securityData.Name,
                    country: security.Country,
                    securityType: securityData.Type,
                    securityId: security.SecurityId
                };
                mockModel.push(newSecurity);
            });
            return mockModel;
        }

        function generatePortfolioHoldingModel(securityReference, xray) {
            var mockModel = [];
            var securities = morningstar.asterix.util.parse('Holdings.PortfolioHoldings.Security')(xray) || [];

            _.each(securities, function (security) {
                var data = _.find(securityReference, function (item) {
                    if (item.SecurityId === security.SecurityId) {
                        return item;
                    }
                }) || {};

                var newSecurity = {
                    securityType: data.Type,
                    cusip: data.CUSIP,
                    name: data.Name,
                    symbol: data.TradingSymbol
                };
                _.each(security, function (value, key) {
                    if (!morningstar.asterix.util.isObject(value)) {
                        newSecurity[morningstar.asterix.util.string.firstLowerCase(key)] = value;
                    }
                });

                mockModel.push(newSecurity);
            });
            return mockModel;
        }

        function generateRegionsModel(xray, keyMap) {
            var benchmarkBreakdownModel = {
                benchmark: [],
                breakdown: []
            };

            var portfolio = morningstar.asterix.util.parse('Analysis.EquityAnalysis.WorldRegions.Portfolio')(xray) || [];
            var benchmark = morningstar.asterix.util.parse('Analysis.EquityAnalysis.WorldRegions.Benchmark')(xray) || [];

            benchmarkBreakdownModel.breakdown.push(generateRegionsElementModel(portfolio, keyMap));
            benchmarkBreakdownModel.benchmark.push(generateRegionsElementModel(benchmark, keyMap));
            return benchmarkBreakdownModel;
        }

        function generateRegionsElementModel(data, keyMap) {
            var regionsElementModel = {
                salePosition: 'N',
                values: {}
            };
            _.each(keyMap, function (mapRegionVal, mapRegionKey) {
                var region = _.findWhere(data, { Id: mapRegionVal.name }) || {};
                if (mapRegionVal.subRegions) {
                    _.each(mapRegionVal.subRegions, function (mapSubRegionVal, mapSubRegionKey) {
                        var subRegion = _.findWhere(region.ExposureItem, { Id: mapSubRegionKey }) || {};
                        regionsElementModel.values[mapSubRegionVal.name] = !_.isUndefined(subRegion.Value) ? subRegion.Value : null;
                    });
                } else {
                    regionsElementModel.values[mapRegionVal.key] = !_.isUndefined(region.Value) ? region.Value : null;
                }
            });

            return regionsElementModel;
        }

        function generateSectorModel(xray, keyMap) {
            var mockModel = {
                benchmark: {
                    values: {}
                },
                portfolio: { values: {} }
            };
            var equitySectorArr = morningstar.asterix.util.parse('Analysis.EquityAnalysis.EquitySectors.EquitySector')(xray) || [];
            var equitySector = equitySectorArr.length > 0 ? equitySectorArr[0] : {};
            var portfolioData = equitySector.Portfolio || [];
            var benchmarkData = equitySector.Benchmark || [];

            mockModel.portfolio.values = generateSectorValues(portfolioData, keyMap);
            mockModel.benchmark.values = generateSectorValues(benchmarkData, keyMap);

            return mockModel;
        }

        function generateSectorValues(data, keyMap) {
            var values = {};
            _.each(data, function (item) {
                if (keyMap[item.Id]) {
                    values[keyMap[item.Id]] = item.Value;
                }
            });
            return values;
        }

        function generateStockOverlapModel(securityReference, xray, sectorMap) {
            var mockModel = [];
            var securities = morningstar.asterix.util.parse('Holdings.StockIntersection.Stock')(xray) || [];
            _.each(securities, function (stock) {
                var stockOverlapObject = {
                    securityName: stock.SecurityName,
                    symbol: stock.TradingSymbol,
                    securityId: stock.SecurityId,
                    percentOfInvestments: stock.PercentOfInvestments,
                    sector: sectorMap[stock.StockSector] ? context.labels.get(sectorMap[stock.StockSector]) : null,
                    marketValue: stock.MarketValue,
                    type: 'st',
                    holdingData: []
                };
                _.each(stock.SourceOfStock, function (holding) {
                    var data = _.find(securityReference, function (item) {
                        if (item.SecurityId === holding.SecurityId) {
                            return item;
                        }
                    }) || {};
                    stockOverlapObject.holdingData.push({
                        securityName: data.Name,
                        symbol: data.TradingSymbol,
                        securityId: holding.SecurityId,
                        percentOfInvestments: holding.PercentOfInvestments,
                        sector: sectorMap[holding.StockSector] ? context.labels.get(sectorMap[holding.StockSector]) : null,
                        holdingPortfolioDate: holding.FundPortfolioDate
                    });
                });
                mockModel.push(stockOverlapObject);
            });
            return mockModel;
        }

        function generateStockStatsModel(xray, keyMap) {
            var mockModel = {
                breakdown: {},
                benchmark: {}
            };
            var equityAnalysis = morningstar.asterix.util.parse('Analysis.EquityAnalysis')(xray) || {};
            var priceRatios = equityAnalysis.PriceRatios || {};
            var profitability = equityAnalysis.Profitability || {};
            var priceRatioPortfolio = priceRatios.Portfolio || {};
            var profitabilityPortfolio = profitability.Portfolio || {};
            var priceRatioBenchmark = priceRatios.Benchmark || {};
            var profitabilityBenchmark = profitability.Benchmark || {};
            var portfolio = morningstar.asterix.util.merge({}, priceRatioPortfolio, profitabilityPortfolio);
            var benchmark = morningstar.asterix.util.merge({}, priceRatioBenchmark, profitabilityBenchmark);

            _.each(keyMap, function (item, name) {
                var breakdownItem = mockModel.breakdown[name] = {},
                    benchmarkItem = mockModel.benchmark[name] = {};

                breakdownItem.value = portfolio[item] || null;
                benchmarkItem.value = benchmark[item] || null;
            });

            return mockModel;
        }

        function generateStyleBoxModel(styleBoxData, startIndex, endIndex) {
            var newData = [];

            _.each(styleBoxData, function (value, key) {
                newData.push(value);
            });

            newData = newData.slice(startIndex, endIndex);
            for (var index = newData.length; index < 9; ++index) {
                newData.push(0);
            }

            return newData;
        }

        function generatePerformanceChartModel(xray, portfolioName) {
            var mockModel = {
                monthly: {
                    series: [{
                        name: portfolioName || 'portfolio',
                        useLabel: portfolioName ? false : true,
                        data: []
                    }, {
                        name: 'benchmark',
                        useLabel: true,
                        data: []
                    }]
                }
            };
            var portfolio = morningstar.asterix.util.parse('Returns.InvestmentActivity.Portfolio')(xray) || [];
            mockModel.monthly.series[0].data = transformPerformanceChartData(portfolio);
            var benchmark = morningstar.asterix.util.parse('Returns.InvestmentActivity.Benchmark')(xray) || [];
            mockModel.monthly.series[1].data = transformPerformanceChartData(benchmark);
            return mockModel;
        }

        function generateTrailingPerformanceModel(xray) {
            var newTrailingReturns = [],
                portfolioTimePeriod = morningstar.asterix.util.parse('Returns.TrailingReturns.Portfolio.TimePeriod')(xray) || [],
                benchmarkTimePeriod = morningstar.asterix.util.parse('Returns.TrailingReturns.Benchmark.TimePeriod')(xray) || [];

            _.each(portfolioTimePeriod, function (data) {
                var benchmarkData = _.find(benchmarkTimePeriod, function (timePeriod) {
                    return timePeriod.Id === data.Id;
                }) || {};

                newTrailingReturns.push({
                    portfolio: data.Value,
                    benchmark: benchmarkData.Value,
                    timePeriod: data.Id
                });
            });

            return newTrailingReturns;
        }

        function transformPerformanceChartData(data) {
            var chartData = [];
            _.each(data, function (item) {
                var value = (item.MarketValue - item.BeginningBalance) / item.BeginningBalance * 100.0;
                var date = morningstar.asterix.util.date.toUTCLocalISOString(new Date(item.EndDate));
                chartData.push({ endDate: date, value: value });
            });
            return chartData;
        }
        return fromXrayData;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(24)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper, dataPointMapping) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromPortfolioAPI', function (xrayData) {
        xrayData = xrayData || {};
        var fromXrayData = {},
            context = this.context,
            xrays = xrayData.data || [],
            hasCurrent = !_.isUndefined(context.parameters.portfolio.current),
            hasProposed = !_.isUndefined(context.parameters.portfolio.proposed);

        if (!hasCurrent && !hasProposed) {
            fromXrayData = generateXrayData(context, xrays[0], context.parameters.portfolio);
        } else {
            if (hasCurrent && hasProposed) {
                fromXrayData.current = generateXrayData(context, xrays[0], context.parameters.portfolio.current);
                fromXrayData.proposed = generateXrayData(context, xrays[1], context.parameters.portfolio.proposed);
            } else {
                var retData = generateXrayData(context, xrays[0], context.parameters.portfolio[hasCurrent ? 'current' : 'proposed']);
                if (hasCurrent) {
                    fromXrayData.current = retData;
                    fromXrayData.proposed = context.instance.model.securities.proposed;
                } else {
                    fromXrayData.proposed = retData;
                    fromXrayData.current = context.instance.model.securities.current;
                }
            }
        }
        return fromXrayData;
    });

    function generateXrayData(context, data, portfolio) {
        var returnDataSections = context.settings.get('returnDataSections'),
            holdings = generateHoldingsModel(context, data),
            newData = {
            benchmark: {
                benchmarkId: helper.getBenchmarkId(portfolio)
            }
        };

        _.each(returnDataSections, function (section) {
            var sectionData = morningstar.asterix.util.parse(section + '.rows')(data) || [],
                sectionDataPointMapping = dataPointMapping[section];
            switch (section) {
                case 'assetAllocation':
                    var assetClassGroupId = helper.getAssetClassGroupId(context);
                    newData.assetAllocation = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping[assetClassGroupId]);
                    break;
                case 'equityStyleBox':
                    newData.equityStyleBox = generateEquityStyleBoxData(sectionData, sectionDataPointMapping);
                    break;
                case 'portfolioHoldings':
                    newData.portfolioHoldings = {
                        holdings: _.map(morningstar.asterix.util.cloneObject(holdings), function (holding) {
                            if (holding.rowType === 'holding' || holding.rowType === 'cash') {
                                holding.marketValue = parseFloat(holding.marketValue) * parseFloat(holding.marketValueRate);
                                if (holding.rowType === 'cash') {
                                    holding.name = context.labels.get('cash');
                                }
                            }
                            return holding;
                        })
                    };
                    break;
                case 'stockRegions':
                    newData.stockRegions = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping);
                    break;
                case 'stockSectors':
                    newData.stockSectors = getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping);
                    break;
                case 'trailingPerformance':
                    sectionData = morningstar.asterix.util.parse('portfolioHoldings.rows')(data) || [];
                    newData.trailingPerformance = generatePortfolioBenchmarkTableModel(getDataArrayByRowType(sectionData, sectionDataPointMapping, ['total', 'benchmark']), 'timePeriod');
                    break;
                case 'stockStats':
                    newData.stockStats = getDataArrayByRowType(sectionData, sectionDataPointMapping, ['total', 'benchmark']);
                    break;
                case 'performanceReturn':
                    var sectionDataNames = morningstar.asterix.util.parse(section + '.columns')(data) || [];
                    newData.performanceChart = generatePerformanceReturnModel(sectionData, sectionDataNames, portfolio);
                    break;
                case 'editHoldings':
                    newData.editHoldings = generateEditHoldingsModel(context, holdings);
                    break;
            }
        });

        return newData;
    }

    function generatePortfolioBenchmarkTableModel(datas, dataPointKey) {
        var newModels = [],
            portfolioData = getRowTypeData(datas, 'total')[0] || {},
            benchmarkData = getRowTypeData(datas, 'benchmark')[0] || {},
            keys = _.uniq(_.keys(portfolioData).concat(_.keys(benchmarkData)));

        _.each(keys, function (key) {
            if (key !== 'rowType') {
                var data = {
                    portfolio: portfolioData[key],
                    benchmark: benchmarkData[key]
                };
                data[dataPointKey] = key;
                newModels.push(data);
            }
        });
        return newModels;
    }

    function generateEquityStyleBoxData(sectionData, sectionDataPointMapping) {
        var holdingStyleDatas = (_.values(sectionData[0])[0] || {}).holdingStyleDatas || [],
            newSectionData = [];

        _.each(sectionDataPointMapping, function (dataPoint) {
            var holdingStyleData = _.findWhere(holdingStyleDatas, { label: dataPoint }) || {};
            newSectionData.push(Number(holdingStyleData.totalWeight || 0));
        });

        return newSectionData;
    }

    function getRowTypeData(sectionData, rowTypes) {
        return _.filter(sectionData, function (item) {
            var rowType = item.rowType;
            if (_.isArray(rowTypes)) {
                return item && _.find(rowTypes, function (type) {
                    return type === rowType;
                });
            } else {
                return item && rowType === rowTypes;
            }
        }) || [];
    }

    function getDataArrayByRowType(sectionData, dataPointMapping, rowTypes) {
        var rowTypeDataArr = getRowTypeData(sectionData, rowTypes),
            newSectionData = [];

        _.each(rowTypeDataArr, function (rowTypeData) {
            newSectionData.push(getDataFromRowTypeData(rowTypeData, dataPointMapping));
        });

        return newSectionData;
    }

    function getDataFromRowTypeData(rowTypeData, dataPointMapping) {
        var data = {};

        _.each(dataPointMapping, function (dataPoints, key) {
            var value = null;
            if (_.isString(dataPoints)) {
                value = rowTypeData[dataPoints];
            } else if (_.isArray(dataPoints)) {
                _.each(dataPoints, function (dataPoint) {
                    if (!morningstar.asterix.util.isUndefinedOrNull(rowTypeData[dataPoint])) {
                        value = value ? value : 0.0;
                        value += rowTypeData[dataPoint];
                    }
                });
            }
            data[key] = morningstar.asterix.util.isUndefinedOrNull(value) ? null : value;
        });

        return data;
    }

    function getDataBySectionDataPointMapping(sectionData, sectionDataPointMapping) {
        var retDataPointMapping = {
            portfolio: 'total',
            benchmark: 'benchmark'
        },
            newSectionData = {};

        _.each(retDataPointMapping, function (rowType, dataPoint) {
            var rowTypeData = getRowTypeData(sectionData, rowType)[0] || {},
                newDataPointMapping = {},
                retData = {};

            _.each(sectionDataPointMapping, function (dataPointMapping, key) {
                if (_.isString(dataPointMapping) || _.isArray(dataPointMapping)) {
                    newDataPointMapping[key] = dataPointMapping;
                } else if (_.isObject(dataPointMapping)) {
                    retData[key] = getDataFromRowTypeData(rowTypeData, dataPointMapping);
                }
            });

            if (!_.isEmpty(newDataPointMapping)) {
                morningstar.asterix.util.merge(retData, getDataFromRowTypeData(rowTypeData, newDataPointMapping));
            }

            newSectionData[dataPoint] = retData;
        });
        return newSectionData;
    }

    function generatePerformanceReturnModel(datas, performanceDataNames, portfolio) {
        var mockModel = {
            monthly: {
                series: []
            }
        },
            portfolioSeriesData = {
            name: 'portfolio',
            useLabel: true,
            data: []
        },
            benchmarkSeriesData = {
            name: 'benchmark',
            useLabel: true,
            data: []
        },
            portfolioData = getRowTypeData(datas, 'total')[0] || {},
            benchmarkData = getRowTypeData(datas, 'benchmark')[0] || {},
            commonStartFlag = false;
        _.each(performanceDataNames, function (item) {
            var id = item.id;
            if (!benchmarkData.performanceId || !portfolioData.performanceId || id !== 'name' && !commonStartFlag && !morningstar.asterix.util.isUndefinedOrNull(portfolioData[id]) && !morningstar.asterix.util.isUndefinedOrNull(benchmarkData[id])) {
                commonStartFlag = true;
            }
            if (commonStartFlag && item.endDate) {
                if (portfolioData.performanceId) {
                    portfolioSeriesData.data.push({ endDate: item.endDate, value: portfolioData[id] });
                }
                if (benchmarkData.performanceId) {
                    benchmarkSeriesData.data.push({ endDate: item.endDate, value: benchmarkData[id] });
                }
            }
        });
        if (portfolioData.performanceId) {
            var name = portfolio.name || portfolioData.name;
            if (name) {
                portfolioSeriesData.name = name;
                portfolioSeriesData.useLabel = false;
            }
            mockModel.monthly.series.push(portfolioSeriesData);
        }
        if (benchmarkData.performanceId) {
            var _name = benchmarkData.name;
            if (_name) {
                benchmarkSeriesData.name = _name;
                benchmarkSeriesData.useLabel = false;
            }
            benchmarkSeriesData.id = benchmarkData.performanceId;
            mockModel.monthly.series.push(benchmarkSeriesData);
        }
        return mockModel;
    }

    function generateHoldingsModel(context, data) {
        var sectionData = morningstar.asterix.util.parse('portfolioHoldings.rows')(data) || [];
        var holdings = getDataArrayByRowType(sectionData, dataPointMapping.portfolioHoldings, 'holding');
        var cash = getDataArrayByRowType(sectionData, dataPointMapping.portfolioHoldings, 'cash');
        return holdings.concat(cash);
    }

    function generateEditHoldingsModel(context, holdings) {
        var editHoldings = [];
        var totalAmount = 0;

        _.each(holdings, function (holding) {
            var newHolding = {
                identifier: holding.secId,
                performanceId: holding.performanceId,
                name: holding.name,
                units: parseFloat(holding.shares),
                price: parseFloat(holding.price) * parseFloat(holding.priceRate),
                weight: parseFloat(holding.weight),
                amount: parseFloat(holding.marketValue),
                identifierType: 'MSID'
            };
            totalAmount += holding.marketValue;
            if (holding.rowType.toLowerCase() === 'cash') {
                newHolding.performanceId = context.settings.get('cashHoldingIdentifier');
                newHolding.identifier = context.settings.get('cashHoldingIdentifier');
                newHolding.holdingTypeId = context.settings.get('cashHoldingTypeId');
                newHolding.securityType = context.settings.get('cashSecurityType');
            }
            editHoldings.push(newHolding);
        });

        return editHoldings;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.transforms.register('fromUsaReportInfo', function (pipedResult) {
        var reportPortfolios = morningstar.asterix.util.parse('requestData.Portfolios')(pipedResult) || [];
        reportPortfolios[0] = reportPortfolios[0] || {};
        reportPortfolios[0].reportName = morningstar.asterix.util.parse('portfolio.name')(this.origData) || morningstar.asterix.util.parse('portfolio.current.name')(this.origData);

        return reportPortfolios;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toEcBenchmarkAPI', function () {
        return {
            parameters: helper.generatePAAPIUrlParameters(this.context)
        };
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toIwtXray', function (parameters) {
        return helper.generateIWTPostData(this.context, parameters);
    });

    morningstar.asterix.ng.transforms.register('toIwtFees', function (parameters) {
        return helper.generateIWTFeesPostData(this.context, parameters);
    });

    morningstar.asterix.ng.transforms.register('toIwtXrayCurrent', function (parameters) {
        return helper.generateIWTPostData(this.context, parameters, 'current');
    });

    morningstar.asterix.ng.transforms.register('toIwtXrayProposed', function (parameters) {
        return helper.generateIWTPostData(this.context, parameters, 'proposed');
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toPAAPI', function (parameters) {
        var apiViewConfigDefinitions = this.context.settings.get('apiViewConfigDefinitions') || {},
            assetClassGroupId = helper.getAssetClassGroupId(this.context),
            portfolio = parameters.portfolio.current || parameters.portfolio.proposed || parameters.portfolio,
            currencyId = portfolio.currencyId || this.context.settings.get('currencyId'),
            postData = {
            parameters: helper.generatePAAPIUrlParameters(this.context),
            requestData: {
                View: {
                    Id: apiViewConfigDefinitions.view
                },
                Config: {
                    Id: apiViewConfigDefinitions.config
                },
                RequestSettings: {
                    OutputCurrency: currencyId
                },
                Portfolios: helper.generatePAAPIPortfolios(this.context, parameters.portfolio)
            }
        };

        if (assetClassGroupId) {
            postData.requestData.RequestSettings.AssetClassGroupConfigs = {
                AssetClassGroupConfig: [{
                    Id: assetClassGroupId
                }]
            };
        }
        if (apiViewConfigDefinitions.endpoint === 'hypo') {
            postData.requestData.RequestSettings.hypoCalculationSettings = this.context.parameters.hypotheticalSettings || this.context.settings.get('hypotheticalSettings');
        }

        return postData;
    });
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _, helper) {
    'use strict';

    morningstar.asterix.ng.transforms.register('toPortfolioAPIAdvanced', function (parameters) {
        return {
            parameters: helper.generatePAAPIUrlParameters(this.context),
            requestData: {
                settings: generateSettings(this.context, parameters),
                portfolios: generateAdvancedPortfolios(parameters)
            }
        };
    });

    morningstar.asterix.ng.transforms.register('toPortfolioAPIBasic', function (parameters) {
        return {
            parameters: helper.generatePAAPIUrlParameters(this.context),
            requestData: {
                settings: generateSettings(this.context, parameters),
                portfolios: generateBasicPortfolios(this.context, parameters)
            }
        };
    });

    function generateSettings(context, parameters) {
        var portfolio = parameters.portfolio || [],
            settings = morningstar.asterix.extend(true, {}, context.settings.get('portfolioApiSettings'));
        settings.assetClassGroupId = helper.getAssetClassGroupId(context);
        settings.benchmarkId = helper.getBenchmarkId(portfolio[0]);
        settings.returnDataSections = context.settings.get('returnDataSections');
        return settings;
    }

    function generateAdvancedPortfolios(parameters) {
        var newPortfolios = [],
            tempPortfolios = generateTempPortfolios(parameters.portfolio || {});

        _.each(tempPortfolios, function (portfolio) {
            newPortfolios.push({
                investmentId: portfolio.investmentId,
                name: portfolio.name,
                currency: portfolio.currencyId,
                benchmarkId: helper.getBenchmarkId(portfolio),
                rebalanceFrequencyId: portfolio.rebalanceFrequencyId,
                time: portfolio.time || new Date().getTime()
            });
        });

        return newPortfolios;
    }

    function generateBasicPortfolios(context, parameters) {
        var tempPortfolios = generateTempPortfolios(parameters.portfolio || {}),
            newPortfolios = [],
            defaultTotalAmount = context.settings.get('defaultTotalAmount'),
            identifierTypeMapping = context.settings.get('identifierTypeMapping');

        _.each(tempPortfolios, function (portfolio) {
            var newPortfolio = {
                name: portfolio.name,
                currency: portfolio.currencyId,
                benchmarkId: helper.getBenchmarkId(portfolio),
                rebalanceFrequencyId: portfolio.rebalanceFrequencyId,
                holdings: []
            };

            _.each(portfolio.holdings, function (holding) {
                if (holding.identifier) {
                    var newHolding = {
                        country: holding.country,
                        weight: holding.weight,
                        marketValue: holding.amount,
                        shares: holding.units
                    };

                    if (morningstar.asterix.util.isUndefinedOrNull(newHolding.marketValue) && !morningstar.asterix.util.isUndefinedOrNull(newHolding.weight)) {
                        newHolding.marketValue = defaultTotalAmount * newHolding.weight;
                    }

                    if (holding.identifier.toLowerCase().indexOf('cash') > -1) {
                        newHolding.performanceId = context.settings.get('cashHoldingIdentifier');
                        newHolding.holdingTypeId = 'C';
                    } else {
                        var identifierTypeData = _.find(identifierTypeMapping, { value: holding.identifierType }) || {};
                        newHolding[identifierTypeData.type || 'secId'] = holding.identifier;
                    }
                    newPortfolio.holdings.push(newHolding);
                }
            });

            newPortfolios.push(newPortfolio);
        });

        return newPortfolios;
    }

    function generateTempPortfolios(portfolios) {
        var tempPortfolios = [];

        if (portfolios.current || portfolios.proposed) {
            if (portfolios.current) {
                tempPortfolios.push(portfolios.current);
            }
            if (portfolios.proposed) {
                tempPortfolios.push(portfolios.proposed);
            }
        } else {
            tempPortfolios.push(portfolios);
        }

        return tempPortfolios;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = {
	"ecPortfolioData": {
		"blueprints": {
			"basicDataApi": {
				"settings": {
					"_model": {
						"benchmark": null,
						"securities": {
							"api": {
								"headers": {
									"access_token": "{{_ tokens().accessToken _}}",
									"apiKey": "{{_ tokens().apiKey _}}",
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toPortfolioAPIBasic"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/paapi/v2/xray",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromPortfolioAPI"
							]
						}
					},
					"assetAllocationType": "FACT469"
				},
				"type": "ecPortfolioData"
			},
			"standard": {
				"settings": {
					"_model": {
						"benchmark": null,
						"securities": {
							"api": {
								"headers": {
									"access_token": "{{_ tokens().accessToken _}}",
									"apiKey": "{{_ tokens().apiKey _}}",
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toPortfolioAPIAdvanced"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/paapi/v2/xray",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromPortfolioAPI"
							]
						}
					},
					"assetAllocationType": "FACT469"
				},
				"type": "ecPortfolioData"
			},
			"standardHypo": {
				"settings": {
					"_model": {
						"securities": {
							"api": {
								"headers": {
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toPAAPI"
									],
									"watchedPaths": [
										"portfolio",
										"hypotheticalSettings"
									]
								},
								"url": "https://{{baseUrl}}/portfolioanalysis/v1/hypo?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromPAAPIHypo"
							]
						}
					},
					"apiViewConfigDefinitions": {
						"config": "Default",
						"endpoint": "hypo",
						"view": "Growth"
					},
					"hypotheticalSettings": {
						"ApplyFeeForRebalance": false,
						"ApplySalesCharge": true,
						"AssetBasedAnnualFee": 0,
						"AssetFeeFrequency": "Annually",
						"AssetFeeType": "Percentage",
						"CapitalGainTaxRate": 0,
						"CustomFeeType": "Amount",
						"DividendTaxRate": 0,
						"EntryExitFeeType": "CustomEntry",
						"FederalIncomeTaxRate": 0,
						"FilingStatus": "NoTaxes",
						"FrontLoadType": "Standard",
						"HypoType": "Portfolio",
						"IllustrationTrailingTimePeriod": "EarliestCommon",
						"InvestmentDetailReturnsFrequency": "Monthly",
						"LiquidateOnEndDate": false,
						"PayFees": "SalesOfSharesEnding",
						"PayFeesUseCashFirst": true,
						"PayTaxes": "OutOfPocket",
						"RebalanceFrequency": "None",
						"RebalanceThreshold": 0,
						"ReinvestCapitalGains": true,
						"ReinvestDividends": true,
						"SalesFeeAmount": 0,
						"StateIncomeTaxRate": 0,
						"SubsequentInvestmentAmount": 0,
						"SubsequentInvestmentType": "Invest",
						"SubsequentInvestmentWithdrawalFrequency": "Monthly",
						"SynchronizePortfolioStartDate": true,
						"TaxableIncome": 50000
					},
					"returnDataSections": [
						"hypotheticalGrowth",
						"hypoDates",
						"portfolio",
						"hypotheticalGrowthTable"
					]
				},
				"type": "ecPortfolioData"
			},
			"standardPCUK": {
				"settings": {
					"_model": {
						"benchmark": {
							"api": {
								"url": "https://{{_ settings().baseUrlMorningstarEU _}}/api/rest.svc/{{_ settings().urlKey _}}/security/screener?pageSize=999&outputType=json&universeIds={{_ settings().benchmarkUniverseId _}}&securityDataPoints=SecId|Name"
							}
						},
						"securities": {
							"current": {
								"api": {
									"method": "post",
									"parameters": {
										"deep": true,
										"throttleTime": 200,
										"transformPipeline": [
											"toIwtXrayCurrent"
										],
										"watchedPaths": [
											"portfolio"
										]
									},
									"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
									"usePreviousDataOnError": false,
									"validationExpression": "!!parameters.portfolio.current === true"
								},
								"dataSourceType": "api",
								"transformPipeline": [
									"fromIwtXrayCurrent"
								]
							},
							"proposed": {
								"api": {
									"method": "post",
									"parameters": {
										"deep": true,
										"throttleTime": 200,
										"transformPipeline": [
											"toIwtXrayProposed"
										],
										"watchedPaths": [
											"portfolio"
										]
									},
									"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
									"usePreviousDataOnError": false,
									"validationExpression": "!!parameters.portfolio.proposed === true"
								},
								"dataSourceType": "api",
								"defaults": null,
								"merge": false,
								"transformPipeline": [
									"fromIwtXrayProposed"
								]
							}
						}
					},
					"apiDataPointsSchemaFieldDefinitions": {
						"assetAllocation": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "AssetAllocationMorningstarEUR3"
						},
						"benchmark": {
							"portfolioDataPoints": "BenchmarkId,BenchmarkName"
						},
						"feesExpenses": {
							"outputDataPoints": [
								"hypoWeight",
								"managementFee"
							],
							"portfolioDataPoints": "ManagementFee,ActualManagementFee,OngoingCharge"
						},
						"fixedIncomeDetails": {
							"portfolioDataPoints": "BondStyleBox,EffectiveDuration,EffectiveMaturity,AverageCreditQuality,CreditQuality"
						},
						"performanceGraph": {
							"benchmarkDataPoints": "HistoricalPerformanceSeries",
							"portfolioDataPoints": "HistoricalPerformanceSeries|TotalReturn"
						},
						"portfolioHoldings": {
							"holdingDataPoints": "HoldingId,SecurityId,Symbol,SectorName,ExchangeCode,SecurityType,HoldingType,UniverseId,SecurityToken,Name,ISIN,ClientFund,PortfolioDate,InitialAmount,InitialWeight,Units,MarketValue,Weight,EquityWeighting,BondWeighting,EquityWeightingLong,BondWeightingLong,CurrencyId,CategoryName,SectorName,StarRatingM255,MorningstarRiskM255,SustainabilityRank,AnalystRatingScale,showbreakdown,ShowPerformanceReturn,ShowRiskMeasure,OngoingCharge,PerformanceFee,ActualManagementFee,ActualPerformanceFee,FundShareClassId,ReturnM12,ReturnM36,ReturnM60,ReturnM120",
							"portfolioDataPoints": "UnderlyingHolding|200|HoldingId|SecurityId|SecurityType|Name|MarketValue|Weight|Sector|SectorId|GlobalSectorId|ISIN|CountryId|Country|CurrencyId|CurrencyName|Symbol,HoldingOverlap"
						},
						"stockRegions": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "RegionalExposure"
						},
						"stockSectors": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "GlobalStockSector"
						},
						"stockStats": {
							"portfolioDataPoints": "MarketCapital,ProspectiveEarningsYield,ProspectiveBookValueYield,ProspectiveCashFlowYield,ProspectiveRevenueYield"
						},
						"stockStyle": {
							"portfolioDataPoints": "StyleBox"
						},
						"trailingReturns": {
							"benchmarkDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120|M255|M255UA",
							"portfolioDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120|M255|M255UA"
						}
					},
					"assetAllocationType": "MorningstarEUR3"
				},
				"type": "ecPortfolioData"
			},
			"standardPerformanceUS": {
				"settings": {
					"_model": {
						"securities": {
							"api": {
								"headers": {
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toPAAPI"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/portfolioanalysis/v1/performance?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromPAAPIPerformance"
							]
						}
					},
					"apiViewConfigDefinitions": {
						"config": "QuickPortfolio",
						"endpoint": "performance",
						"view": "Snapshot"
					},
					"returnDataSections": [
						"riskRewardScatterplot"
					]
				},
				"type": "ecPortfolioData"
			},
			"standardRiskRewardUK": {
				"settings": {
					"_model": {
						"securities": {
							"api": {
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toIwtXray"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromIwtXray"
							]
						}
					},
					"apiDataPointsSchemaFieldDefinitions": {
						"riskRewardScatterplot": {
							"benchmarkDataPoints": "ShowRiskMeasure",
							"holdingDataPoints": "Name,Weight,ShowRiskMeasure",
							"portfolioDataPoints": "BenchmarkName,StandardDeviation|M|M12|M36|M60|M120,ArithmeticMean|M|M12|M36|M60|M120"
						}
					},
					"assetAllocationType": "MorningstarEUR3"
				},
				"type": "ecPortfolioData"
			},
			"standardUS": {
				"settings": {
					"_model": {
						"benchmark": {
							"api": {
								"parameters": {
									"transformPipeline": [
										"toEcBenchmarkAPI"
									]
								},
								"url": "https://{{baseUrl}}/portfolioanalysis/v1/benchmark?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}"
							}
						},
						"securities": {
							"api": {
								"headers": {
									"authorization": "{{_ tokens().apiGatewayToken _}}"
								},
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toPAAPI"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/portfolioanalysis/v1/xray?langcult={{languageId}}&{{apiTokenType}}={{apiTokenValue}}",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromPAAPI"
							]
						}
					},
					"apiDataPointsSchemaFieldDefinitions": {
						"feesExpenses": {
							"outputDataPoints": [
								"AverageGrossExpenseRatio",
								"AverageNetExpenseRatio",
								"PotentialCapGainsExposure"
							]
						}
					},
					"apiViewConfigDefinitions": {
						"config": "Default",
						"endpoint": "xray",
						"view": "XrayOverview"
					}
				},
				"type": "ecPortfolioData"
			},
			"standardXrayUK": {
				"settings": {
					"_model": {
						"benchmark": {
							"api": {
								"url": "https://{{_ settings().baseUrlMorningstarEU _}}/api/rest.svc/{{_ settings().urlKey _}}/security/screener?pageSize=999&outputType=json&universeIds={{_ settings().benchmarkUniverseId _}}&securityDataPoints=SecId|Name"
							}
						},
						"securities": {
							"api": {
								"method": "post",
								"parameters": {
									"deep": true,
									"throttleTime": 200,
									"transformPipeline": [
										"toIwtXray"
									],
									"watchedPaths": [
										"portfolio"
									]
								},
								"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/xray/json?languageId={{languageId}}&portfolioDataPoints={{portfolioDataPoints}}&holdingDataPoints={{holdingDataPoints}}&benchmarkDataPoints={{benchmarkDataPoints}}",
								"usePreviousDataOnError": false,
								"validationExpression": "!!parameters.portfolio === true"
							},
							"dataSourceType": "api",
							"transformPipeline": [
								"fromIwtXray"
							]
						}
					},
					"apiDataPointsSchemaFieldDefinitions": {
						"assetAllocation": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "AssetAllocationMorningstarEUR3"
						},
						"benchmark": {
							"portfolioDataPoints": "BenchmarkId,BenchmarkName"
						},
						"correlationMatrix": {
							"holdingDataPoints": "HoldingId,Name",
							"portfolioDataPoints": "CorrelationMatrix|M12"
						},
						"feesExpenses": {
							"outputDataPoints": [
								"managementFee"
							],
							"portfolioDataPoints": "ManagementFee,ActualManagementFee,OngoingCharge"
						},
						"fixedIncomeDetails": {
							"portfolioDataPoints": "BondStyleBox,EffectiveDuration,EffectiveMaturity,AverageCreditQuality,CreditQuality"
						},
						"performanceGraph": {
							"benchmarkDataPoints": "HistoricalPerformanceSeries",
							"portfolioDataPoints": "HistoricalPerformanceSeries|TotalReturn"
						},
						"portfolioFees": {
							"outputDataPoints": [
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"style": "currency"
									},
									"key": "startValue"
								},
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"style": "currency"
									},
									"key": "returnIncludingFeesAmount"
								},
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"style": "currency"
									},
									"key": "returnExcludingFeesAmount"
								},
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"style": "currency"
									},
									"key": "reductionInReturnAmount"
								},
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"suffix": "%"
									},
									"key": "reductionInReturnPercentage"
								},
								{
									"format": {
										"dataType": "number",
										"maximumFractionDigits": 2,
										"minimumFractionDigits": 2,
										"style": "currency"
									},
									"key": "grandTotal"
								}
							]
						},
						"portfolioHoldings": {
							"holdingDataPoints": "HoldingId,SecurityId,Symbol,SectorName,SecurityType,HoldingType,UniverseId,Name,ISIN,PortfolioDate,InitialAmount,InitialWeight,MarketValue,Weight,CurrencyId,StarRatingM255,MorningstarRiskM255,AnalystRatingScale,ShowRiskMeasure,OngoingCharge,FundShareClassId,ReturnM12,ReturnM36,ReturnM60,ReturnM120,ContributionReturn",
							"portfolioDataPoints": "UnderlyingHolding|200|HoldingId|SecurityId|SecurityType|Name|MarketValue|Weight|Sector|SectorId|GlobalSectorId|ISIN|CountryId|Country|CurrencyId|CurrencyName|Symbol,HoldingOverlap"
						},
						"riskScore": {
							"portfolioDataPoints": "PortfolioRiskScore"
						},
						"riskStatistics": {
							"benchmarkDataPoints": "SharpeRatio|M|M12,SharpeRatio|M|M36,StandardDeviation|M|M12,StandardDeviation|M|M36,StandardDeviation|M|M60,ShowRiskMeasure",
							"portfolioDataPoints": "SharpeRatio|M|M12,SharpeRatio|M|M36,StandardDeviation|M|M12,StandardDeviation|M|M36,StandardDeviation|M|M60"
						},
						"stockRegions": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "RegionalExposure"
						},
						"stockSectors": {
							"benchmarkDataPoints": "ShowBreakdown",
							"portfolioDataPoints": "GlobalStockSector"
						},
						"stockStats": {
							"portfolioDataPoints": "MarketCapital,ProspectiveEarningsYield,ProspectiveBookValueYield,ProspectiveCashFlowYield,ProspectiveRevenueYield"
						},
						"stockStyle": {
							"portfolioDataPoints": "StyleBox"
						},
						"timePeriodReturn": {
							"portfolioDataPoints": "BestWorstPeriods|M1|M3|M6|M12|M36|M60"
						},
						"trailingReturns": {
							"benchmarkDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120",
							"portfolioDataPoints": "PerformanceReturn|M0|M1|M2|M3|M6|M12|M36|M60|M120"
						}
					},
					"assetAllocationType": "MorningstarEUR3",
					"feesSettings": {
						"growthRatePercent": 5,
						"yearsToCalculate": 5
					}
				},
				"type": "ecPortfolioData"
			}
		},
		"labels": {
			"cash": {
				"en": "Cash"
			}
		},
		"settings": {
			"_model": {
				"benchmark": {
					"api": {
						"headers": {
							"authorization": "{{_ tokens().apiGatewayToken _}}"
						},
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": [],
							"watchedPaths": [
								"enabledBenchmarkRequest"
							]
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "parameters.enabledBenchmarkRequest",
						"validationExpressions": []
					},
					"dataSourceType": "api",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": []
				},
				"fees": {
					"api": {
						"headers": {
							"Content-Type": "text/plain;charset=UTF-8"
						},
						"method": "post",
						"parameters": {
							"deep": true,
							"throttleTime": 200,
							"transformPipeline": [
								"toIwtFees"
							],
							"watchedPaths": [
								"portfolio"
							]
						},
						"url": "https://{{baseUrl}}/api/rest.svc/{{urlKey}}/investment_fees/calculate",
						"usePreviousDataOnError": false,
						"validationExpression": "settings.get('enabledFeesDataRequest')===true  && !!parameters.portfolio === true"
					},
					"dataSourceType": "api",
					"transformPipeline": [
						"fromIwtFees"
					]
				},
				"securities": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"selector": null,
					"transformPipeline": []
				}
			},
			"_parameters": {
				"enabledBenchmarkRequest": {},
				"feesSettings": {},
				"hypotheticalSettings": {},
				"portfolio": {}
			},
			"apiDataPointsSchema": [
				"benchmark",
				"assetAllocation",
				"stockRegions",
				"stockSectors",
				"performanceGraph",
				"stockStyle",
				"fixedIncomeDetails",
				"stockStats",
				"feesExpenses",
				"trailingReturns",
				"portfolioHoldings",
				"correlationMatrix"
			],
			"apiDataPointsSchemaFieldDefinitions": null,
			"apiViewConfigDefinitions": null,
			"assetAllocationType": null,
			"benchmarkUniverseId": null,
			"cashHoldingIdentifier": "CASH000000",
			"cashHoldingTypeId": 1,
			"cashSecurityType": "C0",
			"defaultTopNetUnderlyingHoldingsAmount": 10,
			"defaultTotalAmount": 10000,
			"enabledBenchmarkRequest": null,
			"enabledFeesDataRequest": false,
			"feesSettings": null,
			"hypotheticalSettings": null,
			"identifierTypeMapping": [
				{
					"type": "secId",
					"value": "MSID"
				},
				{
					"type": "performanceId",
					"value": "PrefId"
				},
				{
					"type": "ticker",
					"value": "Ticker"
				},
				{
					"type": "isin",
					"value": "ISIN"
				},
				{
					"type": "cusip",
					"value": "CUSIP"
				},
				{
					"type": "fundCode",
					"value": "FundCode"
				}
			],
			"maxNoOfCalendarYearsReturns": 5,
			"numberOfYearsReturns": 0,
			"portfolio": null,
			"portfolioApiSettings": null,
			"returnDataSections": [
				"assetAllocation",
				"calendarYearsReturns",
				"creditQuality",
				"editHoldings",
				"equityStyleBox",
				"feesExpenses",
				"fixedIncomeStyleBox",
				"interestRateRisk",
				"performanceReturn",
				"stockStats",
				"portfolioHoldings",
				"stockOverlap",
				"stockRegions",
				"stockSectors",
				"trailingPerformance",
				"correlationMatrix",
				"topNetUnderlyingHoldings"
			],
			"urlKey": null
		},
		"type": "ecPortfolioData"
	}
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecPortfolioData', __webpack_require__(18).ecPortfolioData);
    __webpack_require__(4);
    __webpack_require__(5);
    __webpack_require__(11);
    __webpack_require__(9);
    __webpack_require__(10);
    __webpack_require__(16);
    __webpack_require__(8);
    __webpack_require__(6);
    __webpack_require__(15);
    __webpack_require__(14);
    __webpack_require__(17);
    __webpack_require__(12);
    __webpack_require__(13);
    __webpack_require__(7);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    var editHoldingsHelper = {
        generateHoldings: generateHoldings,
        generateHoldingType: generateHoldingType,
        recalculateEditHoldingsWeight: recalculateEditHoldingsWeight,
        isValidTotalWeight: isValidTotalWeight,
        isEqualTo100: isEqualTo100,
        calculateTotalAmount: calculateTotalAmount,
        setEditHoldingsModel: setEditHoldingsModel
    };

    angular.module('ecPortfolioData').factory('portfolioDataEditHoldingsHelperService', function () {
        return editHoldingsHelper;
    });

    // keep this so we can use it in the transforms/helper.js
    return editHoldingsHelper;

    function generateHoldingType(holdings) {
        if (holdings && holdings[0]) {
            if (holdings[0].holdingType) {
                return holdings[0].holdingType;
            } else if (holdings[0].amount) {
                return 'amount';
            } else if (holdings[0].units) {
                return 'units';
            } else {
                return 'weight';
            }
        }
    }

    function generateHoldings(holdings, holdingType) {
        var newHoldings = [];
        if (holdingType) {
            _.each(holdings, function (holding) {
                if (isValidHolding(holding, holdingType)) {
                    var newHolding = {
                        identifier: holding.identifier || null,
                        identifierType: 'MSID',
                        securityType: holding.securityType || null,
                        name: holding.name || null,
                        holdingType: holdingType,
                        weight: holding.weight || null
                    };
                    newHolding[holdingType] = holding[holdingType];
                    newHoldings.push(newHolding);
                }
            });
        }
        return newHoldings;
    }

    function setEditHoldingsModel(editHoldingsInstance, securities, portfolioType) {
        var editHoldingsModel = morningstar.asterix.util.parse(portfolioType ? portfolioType + '.editHoldings' : 'editHoldings')(securities);
        if (editHoldingsModel) {
            editHoldingsInstance.setModelProperty('holdings', editHoldingsModel);
        }
    }

    function recalculateEditHoldingsWeight(editHoldings) {
        var totalAmount = 0;
        _.each(editHoldings.valid, function (holding) {
            totalAmount = totalAmount + holding.amount;
        });
        editHoldings.totalAmount = totalAmount;
        _.each(editHoldings, function (holding) {
            if (_.findWhere(editHoldings.valid, { identifier: holding.identifier })) {
                holding.weight = holding.amount / totalAmount * 100.0;
            }
        });
    }

    function isValidTotalWeight(holdings) {
        var totalWeight = 0;
        _.each(holdings, function (holding) {
            if (isValidHolding(holding, 'weight')) {
                totalWeight = totalWeight + holding.weight;
            }
        });
        return isEqualTo100(totalWeight);
    }

    function isEqualTo100(value) {
        return Math.round(value * 10) / 10 === 100;
    }

    function calculateTotalAmount(holdings) {
        var totalAmount = 0;
        _.each(holdings, function (holding) {
            if (isValidHolding(holding, 'amount')) {
                totalAmount += holding.amount;
            }
        });
        return totalAmount;
    }

    function isValidHolding(holding, holdingType) {
        return holding && holding[holdingType] && holding.identifier && holding.identifier.indexOf('EMPTY_') === -1;
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {
	"identifierTypePAAPI": [
		{
			"key": "securityid",
			"value": "SecurityId"
		},
		{
			"key": "msid",
			"value": "SecurityId"
		},
		{
			"key": "ticker",
			"value": "TradingSymbol"
		},
		{
			"key": "cusip",
			"value": "CUSIP"
		},
		{
			"key": "fundcode",
			"value": "FundCode"
		}
	],
	"AssetClassGroupIdMapping": {
		"MorningstarUSA": "ACG-USBROAD",
		"MorningstarCABroad": "ACG-CABROAD",
		"ACG-Detailed-NML2": "ACG-Detailed-NML2"
	}
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = {
	"stockOverlap": {
		"101": "basicMaterials",
		"102": "consumerCyclical",
		"103": "financialServices",
		"104": "realEstate",
		"205": "consumerDefensive",
		"206": "healthcare",
		"207": "utilities",
		"308": "communicationServices",
		"309": "energy",
		"310": "industrials",
		"311": "technology"
	}
};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {
	"assetAllocation": {
		"idMap": {
			"ACG-USBROAD": "MorningstarUSA",
			"ACG-CABROAD": "MorningstarCABroad",
			"ACG-Detailed-NML2": "ACG-Detailed-NML2"
		},
		"MorningstarUSA": {
			"AC-USEQ": "1",
			"AC-NUSEQ": "2",
			"AC-ALLBOND": "3",
			"AC-USCASH": "4",
			"AC-USBROAD-OTHER": "5"
		},
		"MorningstarCABroad": {
			"AC-CANCASH": "1",
			"AC-CANEQ": "2",
			"AC-USEQ-XOI": "3",
			"AC-NUSNCANEQ": "4",
			"AC-ALLBOND-XOI": "5",
			"AC-CANOTHER": "6"
		},
		"ACG-Detailed-NML2": {
			"AC-USLCEQ-NML": "1",
			"AC-USMCEQ-NML": "2",
			"AC-USSCEQ-NML": "3",
			"AC-NUSEQ-NML": "4",
			"AC-EMERGEQ-NML2": "5",
			"AC-REALESTATE-NML": "6",
			"AC-COMMODITIES-NML": "7",
			"AC-FIXEDINC-NML2": "8",
			"AC-USCASH-BROAD-PFS": "9",
			"AC-USOTHER-NML2": "10"
		}
	},
	"bondStatistics": {
		"averageCreditQuality": "AverageCreditQuality",
		"averageWtdCoupon": "WTDCoupon",
		"effectiveDuration": "EffectiveDuration",
		"effectiveMaturity": "Maturity"
	},
	"creditQuality": {
		"A": "4",
		"AA": "3",
		"AAA": "2",
		"B": "7",
		"BB": "6",
		"BBB": "5",
		"BelowB": "8",
		"NotRated": "9"
	},
	"equityStatistics": {
		"prospectiveEarningsYield": "PriceEarnings",
		"prospectiveBookValueYield": "PriceBook",
		"prospectiveRevenueYield": "PriceSales",
		"prospectiveCashFlowYield": "PriceCashFlow",
		"returnOnEquity": "ROE",
		"returnOnAssets": "ROA"
	},
	"globalStockSectors": {
		"BasicMaterials": "101",
		"CommunicationServices": "308",
		"ConsumerCyclical": "102",
		"ConsumerDefensive": "205",
		"Energy": "309",
		"FinancialServices": "103",
		"Healthcare": "206",
		"Industrials": "310",
		"RealEstate": "104",
		"Technology": "311",
		"Utilities": "207"
	},
	"regionalExposure": {
		"americas": {
			"name": "Americas",
			"subRegions": {
				"LatinAmerica": {
					"type": "americas",
					"name": "3",
					"key": "3"
				},
				"NorthAmerica": {
					"type": "americas",
					"name": "1",
					"key": "1"
				}
			}
		},
		"asia": {
			"name": "GreaterAsia",
			"subRegions": {
				"AsiaDeveloped": {
					"type": "asia",
					"name": "12",
					"key": "12"
				},
				"AsiaEmerging": {
					"type": "asia",
					"name": "13",
					"key": "13"
				},
				"Australia": {
					"type": "asia",
					"name": "11",
					"key": "11"
				},
				"Japan": {
					"type": "asia",
					"name": "10",
					"key": "10"
				}
			}
		},
		"europe": {
			"name": "GreaterEurope",
			"subRegions": {
				"AfricaMiddleEast": {
					"type": "europe",
					"name": "8",
					"key": "8"
				},
				"EuropeDeveloped": {
					"type": "europe",
					"name": "6",
					"key": "6"
				},
				"EuropeEmerging": {
					"type": "europe",
					"name": "7",
					"key": "7"
				},
				"UnitedKingdom": {
					"type": "europe",
					"name": "4",
					"key": "4"
				}
			}
		},
		"notClassified": {
			"name": "NotClassified",
			"key": "99"
		}
	},
	"stockSectors": {
		"a1": "basicMaterials",
		"a2": "consumerCyclical",
		"a3": "financialServices",
		"a4": "realEstate",
		"b1": "communicationServices",
		"b2": "energy",
		"b3": "industrials",
		"b4": "technology",
		"c1": "consumerDefensive",
		"c2": "healthcare",
		"c3": "utilities"
	}
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = {
	"assetAllocation": {
		"FACT469": {
			"stock": {
				"N": "FACT469_PARM38_OPTION105",
				"L": "FACT469_PARM38_OPTION105_26056",
				"S": "FACT469_PARM38_OPTION105_26057"
			},
			"bond": {
				"N": "FACT469_PARM38_OPTION100",
				"L": "FACT469_PARM38_OPTION100_26056",
				"S": "FACT469_PARM38_OPTION100_26057"
			},
			"cash": {
				"N": "FACT469_PARM38_OPTION101",
				"L": "FACT469_PARM38_OPTION101_26056",
				"S": "FACT469_PARM38_OPTION101_26057"
			},
			"pref": {
				"N": "FACT469_PARM38_OPTION104",
				"L": "FACT469_PARM38_OPTION104_26056",
				"S": "FACT469_PARM38_OPTION104_26057"
			},
			"convert": {
				"N": "FACT469_PARM38_OPTION102",
				"L": "FACT469_PARM38_OPTION102_26056",
				"S": "FACT469_PARM38_OPTION102_26057"
			},
			"other": {
				"N": "FACT469_PARM38_OPTION103",
				"L": "FACT469_PARM38_OPTION103_26056",
				"S": "FACT469_PARM38_OPTION103_26057"
			}
		}
	},
	"stockRegions": {
		"americas": {
			"northAmerica": [
				"26729",
				"26718"
			],
			"latinAmerica": "26725"
		},
		"asia": {
			"asiaDeveloped": "26715",
			"asiaEmerging": "26716",
			"australasia": "26717",
			"japan": "26724"
		},
		"europe": {
			"africaMiddleEast": [
				"26714",
				"26726"
			],
			"europeDeveloped": [
				"26722",
				"26723"
			],
			"europeEmerging": "26721",
			"unitedKingdom": "26728"
		}
	},
	"equityStyleBox": [
		"large_value",
		"large_blend",
		"large_growth",
		"medium_value",
		"medium_blend",
		"medium_growth",
		"small_value",
		"small_blend",
		"small_growth"
	],
	"portfolioHoldings": {
		"clientSecurityId": "clientSecurityId",
		"date": "date",
		"marketValue": "marketValue",
		"marketValueRate": "marketValueRate",
		"morningstarAnalystRating": "FACT2319",
		"name": "name",
		"performanceId": "performanceId",
		"returnM1": "FACT830_1",
		"returnM3": "FACT830_2",
		"returnM6": "FACT830_3",
		"returnYTD": "FACT830_4",
		"returnY1": "FACT830_5",
		"returnY3": "FACT830_6",
		"secId": "secId",
		"sortValue": "sortValue",
		"styleBoxEQ": "FACT973_7",
		"styleBoxFI": "FACT973_8",
		"ticker": "ticker",
		"universe": "universe",
		"weight": "weight",
		"price": "price",
		"shares": "shares",
		"priceCurrency": "priceCurrency",
		"priceRate": "priceRate",
		"rowType": "rowType"
	},
	"trailingPerformance": {
		"marketValue": "marketValue",
		"rowType": "rowType",
		"M1": "FACT830_1",
		"M3": "FACT830_2",
		"M6": "FACT830_3",
		"M0": "FACT830_4",
		"M12": "FACT830_5",
		"M36": "FACT830_6"
	},
	"stockSectors": {
		"basic-materials": "FACT1106_PARM69_OPTION24076",
		"consumer-cyclical": "FACT1106_PARM69_OPTION24078",
		"financial-services": "FACT1106_PARM69_OPTION24081",
		"real-estate": "FACT1106_PARM69_OPTION24084",
		"consumer-defensive": "FACT1106_PARM69_OPTION24079",
		"healthcare": "FACT1106_PARM69_OPTION24082",
		"utilities": "FACT1106_PARM69_OPTION24086",
		"communication-services": "FACT1106_PARM69_OPTION24077",
		"energy": "FACT1106_PARM69_OPTION24080",
		"industrials": "FACT1106_PARM69_OPTION24083",
		"technology": "FACT1106_PARM69_OPTION24085"
	},
	"stockStats": {
		"marketCapital": "Average_Market_Cap_Long",
		"priceBookRatio": "P_B_Ratio_Long",
		"priceSalesRatio": "P_S_Ratio_Long",
		"priceCashRatio": "P_Cash_Flow_Ratio_Long",
		"netMarginLong": "Net_Margin_Long",
		"priceEarningsRatio": "P_E_Ratio_Long",
		"returnOnEquity": "ROE",
		"returnOnAssets": "ROA",
		"rowtype": "rowType"
	}
};

/***/ })
/******/ ]);
//# sourceMappingURL=ec-portfolio-data.js.map


// WEBPACK FOOTER //
// ./components/portfolio-data/build/ec-portfolio-data.js